<template>
  <div id="sov">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader || loader3 || loader4 || brandLoader ">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div> 
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  		  <div class="datebox">
          <select @change="siteChange" v-model="selected_website" class="form-control text-uppercase">
            <option value="https://www.hp.com/in-en">HP India</option>
            <option value="https://www.hp.com/in-en#commercial">Commercial HP India</option>
            <option value="https://global.jd.com">JD GC</option>
          	<option value="https://www.amazon.in">Amazon</option>
          	<option  value="https://www.amazon.in/gp/bestsellers">Amazon Bestsellers</option>
          	<option value="https://www.flipkart.com">Flipkart</option>
          </select>
        </div>
      	<div v-if="!oemSites.includes(selected_website)" class="datebox">
  	 			<datepicker :disabled="date.disabled.startRange" placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
         <div class="datebox">
  	 			<datepicker :disabled="date.disabled.endRange" placeholder="From" @input="changeCustomDate" v-model="date.endDate" />
  	 		</div>
  	 		
        <div class="datebox">
          <select v-model="device" @change="refresh"  class="form-control text-uppercase">
            <option value="laptop">Laptop</option>
            <option v-if="checkDeviceOption()" value="gaming_laptop">Gaming Laptop</option>
            <option v-if="checkDeviceOption()" value="non_gaming_laptop">Non Gaming Laptop</option>
            <option v-if="checkDeviceOption()" value="processor">Processor</option>
          </select>
        </div>
         <div v-if="!oemSites.includes(selected_website)" class="datebox">
          <select v-model="selectedBrand"  class="form-control text-uppercase">
            <option value="">All</option>
            <option v-for="d in brandListOptions" :key="d" :value="d">{{d.toUpperCase()}}</option>
          </select>
        </div>
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
  	</div>
    <div class="container-fluid" v-if="retail_websites.includes(selected_website)">
      <div>
        <div class="space-between-header" >
          <h4 style="max-width:50%">{{ deviceMapper[device] }} Trends</h4>
          <div> 
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="sovInterval" name="radiosBtn">
                <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                <b-form-radio class="mx-0" value="month">Month</b-form-radio>
              </b-form-radio-group>
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
              <datepicker  placeholder="From" @input="getDailyData" v-model="sovStartDate" />
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
              <datepicker class="picker-left"   placeholder="To" @input="getDailyData" v-model="sovEndDate" />
                  
            </b-button-toolbar>
          </div>
        </div> 
        <div class="space-between-header">
          <h4>SOV trend for {{ deviceMapper[device] }} category page 1</h4>
        </div>  
        <div class="card p-2">
          <highcharts style="width:100%;" :options="daywiseChartPage1" ></highcharts>
        </div>
        <div class="space-between-header">
          <h4>SOV trend for {{ deviceMapper[device] }} category pages (1-3)</h4>
        </div>  
        <div class="card p-2">
          <highcharts style="width:100%;" :options="daywiseChart" ></highcharts>
        </div>
        <div v-if="selected_website=='https://global.jd.com'">
          <div class="space-between-header">
            <h4>SOV trend for Gaming {{ deviceMapper[device] }} category pages (1-3)</h4>
          </div>  
          <div class="card p-2">
            <highcharts style="width:100%;" :options="daywiseChartGaming" ></highcharts>
          </div>
          <div class="space-between-header">
            <h4>Average SOV trend for {{ deviceMapper[device] }} category pages (1-3)</h4>
          </div>  
          <div class="card p-2">
            <highcharts style="width:100%;" :options="daywiseChartAverage" ></highcharts>
          </div>
        </div>
      </div>
      <div>
          <div class="space-between-header">
            <h4>SOV Trend for Position On {{ deviceMapper[device] }} category page</h4>
          </div>  
          <div class="card p-2">
            <highcharts style="width:100%;" :options="daywisePositionChart" ></highcharts>
          </div>
        </div>  
        <div >
           <div class="space-between-header" >
            <h4 >Trend for AMD {{ deviceMapper[device] }} count</h4>
          </div>  
          <div class="card p-2">
            <highcharts style="width:100%;"  :options="daywiseAMDCount" ></highcharts>
          </div>
          <div v-if="selected_website=='https://global.jd.com'">
            <div class="space-between-header" >
              <h4 >Trend for AMD Gaming {{ deviceMapper[device] }} count</h4>
            </div>  
            <div class="card p-2">
              <highcharts style="width:100%;"  :options="daywiseAMDCountGaming" ></highcharts>
            </div>
            <div class="space-between-header" >
              <h4 >Average Trend for AMD {{ deviceMapper[device] }} count</h4>
            </div>  
            <div class="card p-2">
              <highcharts style="width:100%;"  :options="daywiseAMDCountAverage" ></highcharts>
            </div>
          </div>
          <div>
             <div class="space-between-header"> 
                <h3 >{{ deviceMapper[device] }} Category Data </h3>
                  <div> 
                    <span style="line-height: 31px;margin-right: 10px;}">Pages:</span>
                    <select @change="readyPie" v-model="selectedPage" class="form-control text-uppercase">
                      <option value="1-3">1-3</option>
                      <option value="1">1</option>
                    </select>
                  </div>  
              </div> 
              <h4 style="display:inline-block">All Listing</h4>
              <div  class="row">
                <div class="col-sm-4 mycols">
                  <div class="card">
                    <highcharts style="width:100%" v-if="activePie" :options="pieChartAMDTotal" ></highcharts>
                    <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;">Total {{ deviceMapper[device] }}: {{ pieTotalAll }}</span>
                  </div>
                </div>  
                    
                <div class="col-sm-4 mycols"  v-for="(d,i) in old_count">
                  <div class="card">
                    <highcharts style="width:100%" :options="old_pieChart[i]" ></highcharts>
                    <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;">Total {{ deviceMapper[device] }}: {{ pieTotalAll }}</span>
                  </div>
                </div>  
              </div>  
        
            <div class="">
              <h4 style="display:inline-block">AMD Listing</h4>
              <div @click="goToDetailPage" class="sovdetails listing-custom badge badge-primary">Show Details</div>
          
              <select class="form-control text-uppercase" style="float:right;width:170px;border:1px solid #c5c5c5" v-model="amdCPUFilter" @change="readyPie" >
                <option value="all">All AMD {{ deviceMapper[device] }}</option>
                <option value="ryzen">Ryzen {{ deviceMapper[device] }}</option>
                <option value="non_ryzen" >Non-Ryzen {{ deviceMapper[device] }}</option>
              </select>
              
              <div class="row">        
                <div :class="showBrandHP ? 'col-sm-6 mycols':'col-sm-12 mycol'" v-for="(d,i) in labelMapper"  >
                  <div class="card">
                    <highcharts style="width:100%" v-if="activePie" :options="pieChartAMD[i]" ></highcharts>             
                    <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;" >
                    <span v-if="amdCPUFilter=='all'">Total AMD {{ deviceMapper[device] }}: </span>  
                    <span v-if="amdCPUFilter=='ryzen'">Total Ryzen {{ deviceMapper[device] }}: </span>  
                    <span v-if="amdCPUFilter=='non_ryzen'">Total Non-Ryzen {{ deviceMapper[device] }}: </span>  
                      {{ pieTotal }}</span>
                  </div>
                </div>  
              </div>    
            </div>
          </div>
        </div>  
        <div>
          <div v-if="selected_website!='all' && priceBandResponse.chart1.length" style='margin-bottom:10px'>
            <div class="space-between-header"> 
                <h4>SOV By Priceband  </h4>
              </div> 
              <b-row>
                <div :class="{'mycols':priceBandResponse.chart1.length && priceBandResponse.chart2.length }" class="col-md-6 " v-if="priceBandResponse.chart1.length">
                  <div class="space-between-header"> 
                    <h4> </h4>
                      <div> 
                        <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                          <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
                          <datepicker  placeholder="From" @input="getPriceBands" v-model="priceBandData.chart1.start_date" />
                          <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
                          <datepicker class="picker-left"   placeholder="To" @input="getPriceBands" v-model="priceBandData.chart1.end_date" />
                        </b-button-toolbar>
                      </div>
                  </div>
                  <div class="card">
                    <highcharts style="width:100%" :options="priceBandData.chart1.data" ></highcharts>
                  </div>  
                </div>
                <div :class="{'mycols':priceBandResponse.chart1.length && priceBandResponse.chart2.length }" class="col-md-6 mycols" v-if="priceBandResponse.chart2.length">
                  <div class="space-between-header"> 
                    <h4> </h4>
                      <div> 
                        <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                          <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
                          <datepicker  placeholder="From" @input="getPriceBands" v-model="priceBandData.chart2.start_date" />
                          <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
                          <datepicker class="picker-left"   placeholder="To" @input="getPriceBands" v-model="priceBandData.chart2.end_date" />
                        </b-button-toolbar>
                      </div>
                  </div>
                  <div class="card">
                    <highcharts style="width:100%" :options="priceBandData.chart2.data" ></highcharts>
                  </div>  
                </div>
              </b-row>
            </div>
        </div>
        <div>
          <div class="space-between-header"> 
            <h4>Processor SOV by Priceband</h4>
          
            <div> 
              <b-button-toolbar class="float-left" aria-label="Toolbar with buttons group">
                <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
                <datepicker  placeholder="From" @input="priceBandsProcessor" v-model="pbpStartDate" />
                <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
                <datepicker class="picker-left"   placeholder="To" @input="priceBandsProcessor" v-model="pbpEndDate" />
              </b-button-toolbar>
            
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">Pages</button>
              <select @change="priceBandsProcessor" v-model="pbpPage" class="form-control text-uppercase">
                <option value="1-3">1-3</option>
                <option value="1">1</option>
                <option v-if="isPrice" value="all">All</option>
              </select>
            </div> 
            
          </div>
          <div class="card" v-for="c in priceBandsProcessorGraphs" :key="'pbpc_'+c.title">
            <highcharts style="width:100%" :options="c.chart" ></highcharts>
          </div>  
        </div>
    </div>
    <div class="container-fluid" v-else-if="oemSites.includes(selected_website)">
      <div > 
        <div class="row" >
          <div :class="getClassSOVSOS()" v-for="(d,i) in websiteSOSGraphs" :key="d.key" >
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">{{ d.title }}</p>
                <div @click="goToSovDetailNew" v-if="i ==0" class="sovshowdetails badge badge-primary">Show Details</div>
              </div>
              <highcharts :options="d.chart" ></highcharts>
              </div>  
          </div>
        </div>  
        <div class="space-between-header">
          <h4> Trend for AMD vs Intel  {{ deviceMapper[device] }}</h4>
          <div> 
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="sovIntervalOEM" name="radiosBtn">
                <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                <b-form-radio class="mx-0" value="month">Month</b-form-radio>
              </b-form-radio-group>
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
              <datepicker  placeholder="From" @input="newTrendSOVSOS" v-model="sovStartDate" />
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
              <datepicker class="picker-left"   placeholder="To" @input="newTrendSOVSOS" v-model="sovEndDate" />
            </b-button-toolbar>
          </div>
        </div>
        <div v-for="d in daywiseChartOEM" :key="d.title">
           <div class="space-between-header" >
            <h4>{{d.title}}</h4>
          </div> 
          <div class="card p-2" >
            <highcharts style="width:100%;" :options="d.chart"  ></highcharts>
          </div>
        </div>
        
        <div>
          <div class="space-between-header"> 
              <h3 >{{ deviceMapper[device] }} Category Data </h3>
              <div> 
                  <span style="line-height: 31px;margin-right: 10px;}">Pages:</span>
                  <select @change="readyPie" v-model="selectedPage" class="form-control text-uppercase">
                      <option value="1-3">1-3</option>
                      <option value="1">1</option>
                      </select>
                  </div>  
              </div> 
          <div>
              <h4 style="display:inline-block">AMD Listing</h4>
              <div @click="goToDetailPageOEM" class="sovdetails listing-custom badge badge-primary">Show Details</div>
              
              <select class="form-control text-uppercase" style="float:right;width:170px;border:1px solid #c5c5c5" v-model="amdCPUFilter" @change="readyPie" >
                  <option value="all">All AMD {{ deviceMapper[device] }}</option>
                  <option value="ryzen">Ryzen {{ deviceMapper[device] }}</option>
                  <option value="non_ryzen" >Non-Ryzen {{ deviceMapper[device] }}</option>
              </select>   
          </div>        
          <div class="row">        
              <div class="col-sm-12 mycol" v-for="(d,i) in labelMapper" v-if="i!='brand'"  >
                  <div class="card">
                      <highcharts style="width:100%" v-if="activePie" :options="pieChartAMD[i]" ></highcharts>             
                      <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;" >
                        <span v-if="amdCPUFilter=='all'">Total AMD {{ deviceMapper[device] }}: </span>  
                        <span v-if="amdCPUFilter=='ryzen'">Total Ryzen {{ deviceMapper[device] }}: </span>  
                        <span v-if="amdCPUFilter=='non_ryzen'">Total Non-Ryzen {{ deviceMapper[device] }}: </span>  
                          {{ pieTotal }}
                      </span>
                  </div>
              </div>  
          </div> 
        </div>

        <div v-for="(d,idx) in complianceTrend" :key="'complianceTrend'+d.id+'_'+idx">
          <div class="space-between-header"> 
            <h4 >Trend For Compliance Score</h4>
            <div> 
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
                <datepicker  placeholder="From" @input="getComplianceTrend" v-model="comTrendStartDate" />
                <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
                <datepicker class="picker-left" placeholder="To" @input="getComplianceTrend" v-model="comTrendEndDate" />
              </b-button-toolbar>
            </div>
          </div> 
          <div class="card p-2">
            <lineChart :data="d"/>
          </div>  
        </div>
      </div> 
    </div>
    <div class="container-fluid " v-else>
      <div class="row">
          <div :class="showBrand ? 'col-sm-4': 'col-sm-6'" style="padding-right:2px">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV {{ deviceMapper[device] }} Category</p>
              </div>
              <highcharts :options="charts" v-if="activeChart" ></highcharts>
            </div>
          </div>
          <div class="col-md-4" style="padding-left:2px;padding-right:2px" v-if="showBrand">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV {{ deviceMapper[device] }} Search</p>
              </div>
              <highcharts :options="charts_sos" v-if="activeChart" ></highcharts>
            </div>
          </div>
          <!--<div class="col-md-3" style="padding-left:2px;padding-right:2px" >
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV Category vs Search</p>
              </div>
              <highcharts  :options="sovSOSGraph" v-if="activesovSOSGraph" ></highcharts>
            </div>
          </div>-->
          <div :class="showBrand ? 'col-sm-4': 'col-sm-6'" style="padding-left:2px">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV Position on Page</p>
              </div>
              <highcharts   :options="categorySearchGraph" v-if="activecategorySearchGraph" ></highcharts>
            </div>
          </div>
      </div>    
      

        <div v-if="device!='processor'">
          <div  class="space-between-header">
            <h3 >Price Details for {{ deviceMapper[device] }}</h3>
          </div>
          <div  >
            
            <!-- <highcharts style="width:100%;text-transform:uppercase" :options="priceProcessorStack" ></highcharts> -->
            <div class="row">
              <div v-for="d in priceProcessorPie" class="col-md-3 mycols">
                <div class="card ">
                  
                  <highcharts  style="width:100%;text-transform:uppercase" :options="d.chart" ></highcharts>
                  <div style="text-align:center;padding: 11px;font-size: 12px;margin-top:-40px"> {{ pricePieLabel[d.key] }} </div> 
                </div>
              </div>
            </div>
            <table id="priceTable2" class="table table-bordered" v-show="false">
              <thead class="thead-normal">
                <tr>
                  <th :class="{'amdbg':d.key.indexOf('amd')!=-1,'intelbg':d.key.indexOf('intel')!=-1}" v-for="d in priceTableData.header"> 
                    <span v-if="d.key=='price_range'">{{ d.label  }} (₹) </span>
                    <span v-else>{{ d.label  }}</span></th>
                </tr>
              </thead>
              <tbody class="tbody-normal" > 
                <tr v-for="(r,i) in priceTableData.data" >
                  <td v-for="d in priceTableData.header"> 
                    {{r[d.key]}}
                  </td>
                </tr>
              </tbody>
            </table> 
          </div>  
        </div>    
        <div>
          <div  class="space-between-header">
            <h3 >Price Performance for {{deviceMapper[device]}}</h3>
          </div>
          <div class="card p-2">
          
            <table id="priceTable"  class="table table-bordered" v-show="true">
              <thead class="thead-normal" style="background: #8a87e8!important;color:white">
                <tr>
                  <th style="width:fit-content!important;min-width: 128px;" v-for="d in priceRankReview.headers" > 
                    <span v-if="d.key=='price_range'">{{ d.label  }} (₹) </span>
                    <span v-else>{{ d.label  }}</span></th>
                </tr>
              </thead>
              <tbody class="tbody-normal" > 
                <tr v-for="(r,i) in priceRankReview.data" >
                  <td style="padding:0;vertical-align:top!important" v-for="d in priceRankReview.headers" > 
                    <div v-if="d.key=='price_range'"> {{ r[d.key] }} </div>
                    <div v-if="d.key!='price_range'">
                      <b-row v-if="r[d.key].length" style="margin: 0;">
                          <div class="col-md-2 wsbg" style="padding-bottom: 10px;border-bottom: 1px solid silver;padding-top:10px;text-align:center;border-right: 1px solid silver;" >Processor</div>
                          <div class="col-md-8 wsbg" style="padding-bottom: 10px;border-bottom: 1px solid silver;padding-top:10px;text-align:center;border-right: 1px solid silver;" >Product</div>
                          <div class="col-md-2 wsbg" style="padding-bottom: 10px;border-bottom: 1px solid silver;text-align:center;padding-top:10px;">
                            <span v-if="d.key=='most_reviewed'">Reviews</span>
                            <span v-else>Rank</span>
                          </div>
                      </b-row> 
                      <div class="internalsection" v-for="e in r[d.key]" >
                        <b-row style="margin: 0;">
                          <div class="col-md-2" style="padding-top:10px;height: 104px;text-align:center;border-right: 1px solid silver;" >{{ e.processor.toUpperCase() }}</div>
                          <div class="col-md-8" style="padding-top:10px;height: 104px;text-align:center;border-right: 1px solid silver;" >
                            <a :href="e.link">{{ e.product_name }}</a>
                          </div>
                          <div class="col-md-2" style="text-align:center;padding-top:10px;">
                            <span v-if="d.key=='most_reviewed'">{{ e.reviews }}</span>
                            <span v-else>{{ e.order }}</span>
                          </div>
                        </b-row>  
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table> 
          </div>  
        </div>  

        <div  class="space-between-header">
          <h4 style="width:50%">SOV trend for {{ deviceMapper[device] }} category pages (1-3)</h4>
          <div> 
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="sovInterval" name="radiosBtn">
                <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                <b-form-radio class="mx-0" value="month">Month</b-form-radio>
              </b-form-radio-group>
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
              <datepicker  placeholder="From" @input="getAllDailyData" v-model="sovStartDate" />
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
              <datepicker class="picker-left"   placeholder="To" @input="getAllDailyData" v-model="sovEndDate" />
            </b-button-toolbar>
          </div>
        </div>
        <div class="card p-2">
          <highcharts style="width:100%;" :options="daywiseChart" ></highcharts>
        </div>
        <div v-for ="(d,i) in dailyCompareRyzen">
          <div class="space-between-header">
            <h4 style="text-transform:none">{{ cpuMapper[i] }} SOV</h4>
          </div>
          <div class="card p-2">
            <highcharts style="width:100%;text-transform:none" :options="d" ></highcharts>
          </div>

        </div>  


      
        <div class="space-between-header"> 
          <h3 >{{ deviceMapper[device] }} Category Data </h3>
            <div> 
              <span style="line-height: 31px;margin-right: 10px;}">Pages:</span>
              <select @change="readyPie" v-model="selectedPage" class="form-control text-uppercase">
                <option value="1-3">1-3</option>
                <option value="1">1</option>
              </select>
            </div>  
        </div> 
        <h4 style="display:inline-block">All Listing</h4>
        <div v-if="device!='processor'" class="row">
          <div class="col-sm-4 mycols">
            <div class="card">
              <highcharts style="width:100%" v-if="activePie" :options="pieChartAMDTotal" ></highcharts>
              <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;">Total {{ deviceMapper[device] }}: {{ pieTotalAll }}</span>
            </div>
          </div>  
               
          <div class="col-sm-4 mycols"  v-for="(d,i) in old_count">
            <div class="card">
              <highcharts style="width:100%" :options="old_pieChart[i]" ></highcharts>
              <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;">Total {{ deviceMapper[device] }}: {{ pieTotalAll }}</span>
            </div>
          </div>  
        </div>  
      
        <div v-if="device=='processor'" class="row">
          <div class="col-sm-6 mycols">
            <div class="card">
              <highcharts style="width:100%" v-if="activePie" :options="pieChartAMDTotal" ></highcharts>
              <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;">Total {{ deviceMapper[device] }}: {{ pieTotalAll }}</span>
            </div>
          </div>  
             
          <div class="col-sm-6 mycols"  v-for="(d,i) in old_count" v-if="i!='brand'">
            <div class="card">
              <highcharts style="width:100%" :options="old_pieChart[i]" ></highcharts>
              <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;">Total {{ deviceMapper[device] }}: {{ pieTotalAll }}</span>
            </div>
          </div>  
        </div>  
  
        
      <div class="">
        <h4 style="display:inline-block">AMD Listing</h4>
        <div @click="goToDetailPage" class="sovdetails listing-custom badge badge-primary">Show Details</div>
    
        <select class="form-control text-uppercase" style="float:right;width:170px;border:1px solid #c5c5c5" v-model="amdCPUFilter" @change="readyPie" >
          <option value="all">All AMD {{ deviceMapper[device] }}</option>
          <option value="ryzen">Ryzen {{ deviceMapper[device] }}</option>
          <option value="non_ryzen" >Non-Ryzen {{ deviceMapper[device] }}</option>
        </select>
        
        <div v-show="device!='processor'" class="row">        
          <div :class="showBrandHP ? 'col-sm-6 mycols':'col-sm-12 mycol'" v-for="(d,i) in labelMapper"  >
            <div class="card">
              <highcharts style="width:100%" v-if="activePie" :options="pieChartAMD[i]" ></highcharts>             
              <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;" >
              <span v-if="amdCPUFilter=='all'">Total AMD {{ deviceMapper[device] }}: </span>  
              <span v-if="amdCPUFilter=='ryzen'">Total Ryzen {{ deviceMapper[device] }}: </span>  
              <span v-if="amdCPUFilter=='non_ryzen'">Total Non-Ryzen {{ deviceMapper[device] }}: </span>  
                {{ pieTotal }}</span>
            </div>
          </div>  
        </div>    
        <div v-show="device=='processor'" class="row">        
          <div class="col-sm-12 mycol" v-for="(d,i) in labelMapper" v-if="i!='brand'"  >
            <div class="card">
              <highcharts style="width:100%" v-if="activePie" :options="pieChartAMD[i]" ></highcharts>             
              <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;" >
              <span v-if="amdCPUFilter=='all'">Total AMD {{ deviceMapper[device] }}: </span>  
              <span v-if="amdCPUFilter=='ryzen'">Total Ryzen {{ deviceMapper[device] }}: </span>  
              <span v-if="amdCPUFilter=='non_ryzen'">Total Non-Ryzen {{ deviceMapper[device] }}: </span>  
                {{ pieTotal }}</span>
            </div>
          </div>  
        </div>     

      </div>
        
      <div class="row">
        <div class="col-sm-4 mycols" v-for="d in old_amdVIntelPriceGraphData">
          <div class="card">
            <highcharts style="width:100%" :options="d.chart"  ></highcharts>
          </div>
        </div>  
        <div class="col-sm-8 mycols" v-for="d in old_barGraph">
          <div class="card">
            <highcharts style="width:100%" :options="d.chart"  ></highcharts>
          </div>
        </div>  
      </div> 
    
      
    </div> 
    <div class="container-fluid" v-if="retail_websites.includes(selected_website) || oemSites.includes(selected_website)">
       <div>
          <div class="space-between-header"> 
            <h4 >Compliance Score</h4>
            <h5 style="line-height: 36px;margin-bottom:0;">
              {{ websitesUrls3[selected_website] }}: 
              <span style="color:rgb(53 104 250);">{{ selectedWebComplianceScore }}</span>
            </h5>
            <div @click="goToCompliance" class="sovdetails listing-custom badge badge-primary">Show Details</div>
          </div> 
          <div class="card p-2">
            <highcharts :options="comChart" v-if="activeComChart" ></highcharts> 
          </div>  
        </div> 
       <div v-if="!errorInProduct">
          <div class="space-between-header"> 
            <h3 ></h3>
            <div style="display:inherit" > 
              <div v-if="selected_website == 'https://www.bestbuy.com' || selected_website == 'https://www.amazon.com'" style="display: flex; cursor: pointer;margin-right: 4px;">
                <div  style="padding: 5px; height: 30px; border: none; background: rgb(138, 135, 232); color: white;">
                  <input v-model="sponCheck" style="float: left;margin-right: 6px; margin-top: 3px;" type="checkbox">
                  <span> Sponsored </span>
                </div>
              </div>
              <div @click="showProductModal"  style="display:flex;cursor:pointer" >
                <div style="padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">Products</div>
                <div style="background: white;padding-left: 14px;padding-right: 14px;">
                  <span style="margin-top: 7px;float: left;font-size: 12px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 201px;">{{ selectedProduct.key }}</span>
                  <i style="padding-top: 7px;font-size: 17px;margin-left: 12px;" class="fa fa-angle-down"></i>
                </div>
                <!-- <select @change="refreshReview" v-model="selectedProduct" class="form-control text-uppercase">  
                  <option value="all">All</option>           
                  <option v-for="(d,i) in productOptions" :key="i" :value="d">{{d}}</option>
                </select> -->
              </div>
            
              <div style="margin-left: 6px;padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">From</div>
              <datepicker  placeholder="From" @input="refreshReview" v-model="reviewStartDate" />
              <div style="margin-left: 6px;padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">To</div>
              <datepicker v-model="reviewEndDate" class="picker-left"   placeholder="To" @input="refreshReview" />
              <div  @click="goToSenti" class="sovdetails listing-custom badge badge-primary">Show Reviews</div> 
              </div> 
          </div> 
          <div class="card p-2" style="margin-bottom:4px">
            <div class="space-between-header">
              <h4>Total Reviews: {{ totalReviewCount | format }}</h4>
              <div> 
                <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                  <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="revInterval" name="radiosBtn">
                    <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                    <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                    <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
              </div>
            </div>  
            <highcharts :options="reviewGraph" v-if="activeReviewGraph" ></highcharts>
            <div style="margin:15px"></div>
            <highcharts :options="creviewGraph" v-if="activeReviewGraph" ></highcharts>
          </div>  
          <div class="card p-2">
            <div class="space-between-header">
              <h4 > Avg. Rating: {{ ratingAvg }}</h4>
              <div style="display:flex"> 
                <b-button-toolbar  aria-label="Toolbar with buttons group">
                  <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="revInterval" name="radiosBtn">
                    <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                    <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                    <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
                
              </div>
              
            </div>  
            <highcharts :options="ratingGraph" v-if="activeRatingGraph" ></highcharts>
            <div style="margin:15px"></div>
            <highcharts :options="cratingGraph" v-if="activeReviewGraph" ></highcharts>
            <p style="text-align: center;font-size: 12px;text-transform: initial;">Cumulative Rating = Cumulative Sum of Ratings / Cumulative Sum of Reviews</p>
          </div>   
        </div> 
    </div> 
    <b-modal size="lg" title="Select Product" v-model="isProductModal" >
      <b-row>
        <div class="col-md-12" >
          <div style="position:relative">
            <input style="border-radius: 0;padding: 6px;font-size: 11px;height: 30px;padding-left: 30px;" class="form-control" v-model="schProduct" type="text" placeholder="Search"/>
            <i style="position:absolute;left:0;top:0;padding: 8px;" class="fa fa-search"></i>
          </div>  
        </div>
      </b-row> 
      <b-row class="pt-2" > 
        <div class="col-md-4" v-if="checkChannel()">
          <div class="row">
            <div class="col-md-3">
              <p style="margin-bottom: 0;padding: 7px;">OEM:</p>
            </div>   
            <div class="col-md-9" >
              <select  v-model="brandFilter" @change="changeFilter"  class="form-control">
                <option value="">All</option>
                <option style="text-transform:capitalize" v-for="d in filterKeys.brand" :value="d" :key="d">{{ d.replace('msi','MSI').replace('hp','HP') }}</option>
              </select>
            </div>    
          </div>  
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-2">
              <p style="margin-bottom: 0;padding: 7px;">Processor:</p>
            </div>   
            <div class="col-md-6">
              <select  v-model="cpuFilter" @change="changeFilter" class="form-control fluid">
                <option value="">All</option>
                <option style="text-transform:capitalize" v-for="d in filterKeys.processor_type" :value="d" :key="d">{{ d.replace('amd','AMD') }}</option>
              </select>
            </div>    
          </div>  
        </div>
      </b-row>
      <b-row style="margin-top: 10px;">  
          <div class="col-md-1">
            <p style="margin-bottom: 0;padding: 7px;">Ratings:</p>
          </div>
          <div class="col-md-3   ">
            <select v-model="ratingExp" class="form-control text-uppercase">
              <option value="eq">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="col-md-2 pl-0">
           <input min="0" max="5" v-model="ratingInput1"  style="border: 1px solid silver !important;"  class="form-control filval" type="number" placeholder="Enter Value">
         
          </div>
          <div v-if="ratingExp=='between'" class="col-md-2 pl-0">
           <input min="0" max="5" v-model="ratingInput2"  style="border: 1px solid silver !important;"  class="form-control filval" type="number" placeholder="Enter Value">
         
          </div>
          <div  class="col-md-4 pl-0">
            <button @click="applyRatingFilter"  class="btn filval btn-primary mr-1"> Apply </button>
            <button @click="removeRatingFilter"  class="btn filval btn-danger"> Remove </button>
          </div>
      </b-row>  
      <b-row style="margin-top: 10px;">  
        <div class="col-md-3 pr-0">
          <div style="padding: 5px; height: 30px; border: none; background: rgb(138, 135, 232); color: white;">
            <input @change="changeFilter" v-model="fourKSeries" type="checkbox" style="float: left; margin-right: 6px; margin-top: 3px;">
            <span>4000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pl-1">
          <div style="padding: 5px; height: 30px; border: none; background: rgb(138, 135, 232); color: white;">
            <input @change="changeFilter" v-model="fiveKSeries" type="checkbox" style="float: left; margin-right: 6px; margin-top: 3px;">
            <span>5000 Series</span>
          </div>
        </div>
        
      </b-row>  
      
      <div class="space-between-header" style="padding-top:20px">
        <h6 class="m-0" >Products:</h6>
      </div>       
      <div style="padding-top:0px;cursor:pointer;height: 300px;overflow-y: scroll;">
        <div :class="{'selectedProduct':selectedProduct.key=='all'}" class="eachProduct" @click="selectProductNow({key:'all'})" style="padding: 4px;border-bottom: 1px solid #e6e6e6;" >All
        </div>
        <div :class="{'selectedProduct':selectedProduct.key==d.key}" v-if="checkSearchFilter(d.key) " class="eachProduct" @click="selectProductNow(d)" style="padding: 4px;border-bottom: 1px solid #e6e6e6;" :key="d.key" v-for="d in productOptions" >
          <span>{{ d.key }}</span>
   
        </div>
         
      </div>
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import lineChart from './../commonCharts/lineChart.vue'

export default {
  name: 'sov',
  components: { Datepicker,lineChart },
  data: function () {
    if (localStorage.selected_website)
      this.selected_website = localStorage.selected_website
    else
      this.selected_website = "https://www.amazon.in"
    if (localStorage.selected_category)
      this.selected_category = localStorage.selected_category
    else
      this.selected_category = "laptop"
    return {
      userData: JSON.parse(localStorage.reviewUserData),
    	selected_website:"https://www.amazon.in",
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD'),
        endDate: moment().subtract(1,'days').format('YYYY-MM-DD'),
        disabled: {
          'startRange': {
            from: '',
            to: ''
          },
          'endRange': {
            from: '',
            to: ''
          }
        }
      },
      websitesUrls: {
        "https://www.amazon.in": "amazon_india",
        "https://www.amazon.in/gp/bestsellers": "amazon_bestsellers",
        "https://www.flipkart.com": "flipkart",
        "https://www.hp.com/in-en": 'hp_india',
        "https://global.jd.com": "jd",
        "https://www.hp.com/in-en#commercial": 'commercial_hp_india'
     
      },
      websitesUrls2: {
        "https://www.amazon.com": "amazon",
        "https://www.harveynorman.com.au": "harvey norman",
        "https://www.bestbuy.com": "BESTBUY",
        "https://www.currys.co.uk": "currys uk",
        "https://www.costco.com": "costco",
        "https://www.walmart.com": "walmart",
        "https://store.hp.com/us": "HP",
        "https://global.jd.com": "JD",
        "https://www.hp.com/in-en#commercial": 'Commercial HP India'
      },
      websitesUrls3: {  
        "https://global.jd.com": "JD",
        "https://www.hp.com/in-en": "HP India",
        "https://www.hp.com/in-en#commercial": 'Commercial HP India'
      },
      websitesPriceMap: {
        "https://global.jd.com": "¥",
      },  
      oem_websites:['https://store.hp.com/us'],
      retail_websites: ['https://global.jd.com'],
      oemSites:['https://www.hp.com/in-en','https://www.hp.com/in-en#commercial'],
      columns:[
        {label: 'Brand', field: 'brand', sortable: false},
        {label: 'Sub Brand', field: 'sub_brand', sortable: false},
        {label: 'Form Factor', field: 'form_factor', sortable: false},
        {label: 'Page 1 System Count', field: 'page_1_system_count'},
        {label: 'Page Count (page 1)', field: 'page_1_count'},
        {label: 'Page 1 SOV', field: 'page_1_sov'},

        {label: 'Pages 1-3 System Count', field: 'page_1_3_system_count'},
        {label: 'Pages Count (1-3)', field: 'page_1_3_count'},
        {label: 'Pages 1-3 SOV', field: 'page_1_3_sov'},

        {label: 'All Pages System Count', field: 'page_all_system_count',},
        {label: 'All Pages Count', field: 'page_all_count'},
        {label: 'All Pages SOV', field: 'page_all_sov'},
      ],
      rows:[],
      sos_rows:[],
      rows_details:[],
      page:1,
      charts: {},
      charts_sos:{},
      activeChart: false,
      labelMapper: {
        'brand': 'Brand',
        'processor_type': 'Processor',
        // 'gpu_type': 'GPU'
      },
      isProductModal : false,
      countAMD: {},
      pieChartAMD: {},
      barGraph: {},
      errorInProduct: false,
      activePie: false,
      activeBarChart: false,
      selectedPage: '1-3',
      loader: false,
      pageDistributionData: {},
      sovSOSGraph: {},
      activesovSOSGraph: true,
      categorySearchGraph: {},
      activecategorySearchGraph: true,
      colorShades: {
        red: [
          "#f56464","#fb7878","#fb9178","#fbc778","#f57264","#f56485","#f56492",
        ],
        blue: [
          "#7887fb", "#788dfb","#78a6fb", "#78b2fb","#78d0fb","#78d6fb","#78c4fb"
        ],
        green: [
          "#9af575","#87d866","#80f564","#9bf564","#64f591","#64f570","#71b755",
        ]
      },
      index:{
        red: 0,
        blue: 0,
        green: 0 
      },
      daywiseChart: {},
      dailyData: [],
      amdCPUFilter: 'all' ,
      pieTotal: '',
      pieTotalAll: '',
      comChart: {},
      activeComChart: false,
      selectedProduct: '',
      productOptions: [],
      productOptionsFull: [],
      reviewStartDate: moment().subtract(3,'month').format('YYYY-MM-DD'),
      reviewEndDate: moment().format('YYYY-MM-DD'),
      reviewGraph: {},
      creviewGraph: {},
      activeReviewGraph: false,
      ratingGraph: {},
      cratingGraph:{},
      activeRatingGraph: false,
      totalReviewCount: '',
      ratingAvg: '',
      reviewStarData: {},
      sentimentData: {},
      sentimentChart: {},
      showBrand:true,
      showBrandHP: true,
      activeSentimentChart: false,
      sovInterval: 'day',
      sovStartDate: moment().subtract(1,'week').format('YYYY-MM-DD'),
      sovEndDate: moment().format('YYYY-MM-DD'),
      revInterval: 'month',
      selectedWebComplianceScore: '',
      brand_list:[],
      gpu_list:[],
      schProduct: '',
      deviceMapper:{
        'laptop': 'Laptop PC',
        'gaming_laptop': 'Gaming Laptop',
        'non_gaming_laptop': 'Non Gaming Laptop',
        'processor': 'Processor'
      },
      device: 'laptop',
      cpuFilter: '',
      brandFilter: '',
      filterKeys: {
        brand: [],
        processor_type: []
      },
      oldWebsiteData: [],
      old_labelMapper: {
        'brand': 'Brand',
        'processor_type': 'Processor Model',
      },
      old_count: {},
      old_countAMD: {},
      old_pieChart: {},
      old_pieChartAMD: {},
      old_barGraph: [],
      old_activeBarChart: false,
      old_amdVIntelPriceGraphData: [],
      old_activeAmdIntelGraph: false,
      colorCodes: ['#78b2fb','#cefb78','#fb7878','#b0e1ff','#78eefb','#91ce8e','#59cdfb','#fbd378','#c139a4'],
      priceTableData: {
        header: [],
        data: []
      },
      priceAPIMapper: {
        'laptop': '/api/amazon_india/get_non_gaming_price_bucket',
        'gaming_laptop': '/api/amazon_india/get_gaming_price_bucket',
        'non_gaming_laptop': '/api/amazon_india/get_non_gaming_price_bucket'
      },
      dailyCompareRyzen: {
        cpu3: {},
        cpu5: {},
        cpu7: {},
        cpu9: {}
      },
      cpuMapper: {
        cpu3: 'AMD Ryzen 3 vs Intel Core i3',
        cpu5: 'AMD Ryzen 5 vs Intel Core i5',
        cpu7: 'AMD Ryzen 7 vs Intel Core i7',
        cpu9: 'AMD Ryzen 9 vs Intel Core i9'
      },
      priceProcessorPie: [],
      dailyDataGaming: [],
      priceRankReview: {},
      pricePieLabel: {
        priceBandSOV: '',
        cpu: '',
        cpuModel: '',
        brand: ''
      },
      selectedPriceRange: '',
      selectedCPU: '',
      selectedCPUModelLabel: '',
      selectedCPUModelKey: '',
      selectedBrand: '',
      brandLoader: false,
      ratingExp: 'eq',
      ratingInput1: '',
      pickProduct: false,
      brandListOptions: [],
      websiteSOSGraphs: [],
      sovIntervalOEM: 'day',
      daywiseChartOEM: [],
      complianceTrend: [],
      comTrendStartDate: moment().subtract(1,'month').format('YYYY-MM-DD'),
      comTrendEndDate: moment().format('YYYY-MM-DD'),
      fourKSeries: false, 
      fiveKSeries: false, 
      dailyDataGamingPage13: [],
      dailyDataAveragePage13: [],
      allProcessorData: [],
      page1ProcessorData: [],
      dailyDataPage1: [],
      daywiseChartPage1: {},
      daywiseChartGaming: {},
      daywiseChartAverage: {},
      daywisePositionChart: {},
      daywiseAMDCount: {},
      daywiseAMDCountGaming: {},
      daywiseAMDCountAverage: {},
      priceBandsProcessorGraphs: [],
      pbpPage: '1-3',
      pbpStartDate: moment().subtract(1,'month').format('YYYY-MM-DD'),
      pbpEndDate: moment().format('YYYY-MM-DD'),
      price_sites:[
        "https://global.jd.com"
      ],
      isPrice:false,
      priceBandResponse: {
        chart1: [],
        chart2: []
      },
      priceBandData: {
        chart1: {
          'start_date': moment().subtract(7,'days').format('YYYY-MM-DD'),
          'end_date': moment().subtract(1,'days').format('YYYY-MM-DD'),
          'data': {}
        },
        chart2: {
          'start_date': moment().subtract(14,'days').format('YYYY-MM-DD'),
          'end_date': moment().subtract(8,'days').format('YYYY-MM-DD'),
          'data': {}
        }
      },
    }
  },
  watch:
  {
    'sovIntervalOEM':function(){
      let self = this
      self.newTrendSOVSOS()
    },
    'sovInterval':function(){
      this.getAllDailyData()
    },
    'revInterval':function(){
      if(this.selectedProduct)
        this.getReviews()
    }
  },
  mounted()
  {

    this.reviewStartDate = moment().subtract(3,'week').startOf('year').format('YYYY-MM-DD')
    this.reviewEndDate = this.date.endDate
    this.sovStartDate = moment(this.date.endDate).subtract(1,'week').format('YYYY-MM-DD')
    this.sovEndDate = this.date.endDate
    this.showBrand = true
    this.showBrandHP = true
    this.labelMapper = {
      'brand': 'AMD Brand',
      'processor_type': 'AMD Processor',
      // 'gpu_type': 'GPU'
    }
    if(this.userData.data.amd_india_oem)
      this.selected_website =  "https://www.hp.com/in-en"
    else
      this.selected_website = "https://www.amazon.in"
    if(this.selected_website != 'all')
      localStorage.selected_website = this.selected_website
    localStorage.seleted_category = this.device  
    this.processDisablingDates() 
    if(this.price_sites.includes(this.selected_website))
      this.isPrice = true
    else
      this.isPrice = false 
    
    if(this.retail_websites.includes(this.selected_website)){
      this.getDailyData()
      this.getProducts()
      this.getComData()
      this.website_details()
      this.getPriceBands()
      this.priceBandsProcessor()
    }
    else if(this.oemSites.includes(this.selected_website)){
      this.newTrendSOVSOS()
      this.newSOVSOS()
      this.getComplianceTrend()
      this.getComData()
      this.website_details()
      this.getProducts()
    }
    else
    {
      this.getBrandList()
    }
  },
  methods: {
    priceBandsProcessor(){
      let self = this
      self.priceBandsProcessorGraphs = []
      self.loader = true
      let payload = {
        "website": self.selected_website,
        "start_date": moment(self.pbpStartDate).format('YYYY-MM-DD'),
        "end_date": moment(self.pbpEndDate).format('YYYY-MM-DD'),
        "item_category": self.device
      }
      if (self.pbpPage == '1' || self.pbpPage == 'all' ) payload['page'] = self.pbpPage     
      const url = "/api/websites/price_bands_processor"
      self.$http.post(url, payload ).then(response => {
        if(Object.keys(response.data.data).length) self.processpPriceBandsProcessorGraph(response.data)
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    processpPriceBandsProcessorGraph(data){
      let self = this
      let cat = Object.keys(data.data)
      let catSignChanged = []
      let amdData = []
      let intelData = []
      let appleData = []
      cat.sort(function(a, b) {
        let a1 = a.replace('>','').replace('<','')
        let b1 = b.replace('>','').replace('<','')
        return a1.localeCompare(b1, undefined, { numeric: true, sensitivity: 'base' });
      })
      for (let [idx,dataset] of cat.entries())
      {
        catSignChanged.push(dataset.replace(/\$/g,self.websitesPriceMap[self.selected_website]))
        amdData.push(data.data[dataset].amd_sov)
        intelData.push(data.data[dataset].intel_sov)
        appleData.push(data.data[dataset].apple_sov)

      }
      let obj = {}
      obj.title = 'Processor SOV by Priceband'
      obj.chart = {      
        chart: {
            type: 'column',
            height: 320
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: catSignChanged,
            title:{text:'Total '+ self.deviceMapper[self.device] + ': ' + data.all_count}
        },
        yAxis: {
          title: {
              text: ''
          },
          stackLabels: {
            enabled: true,
            formatter:function(){
              return this.total + '%'
            }
          }  
        },        
        tooltip: {
           enabled: true,
           shared: true,
           valueSuffix: '%'
        },
        plotOptions: {
          column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
                useHTML: true,
                formatter: function() {
                  return  '<span style="z-index:-9999;color:white;font-size:10px;font-weight:normal;background-color:#00000085;padding:4px">' +self.format(Number(this.point.y.toFixed())) + '% </span>'
              }
            }
          }
        },
        series: [{
          name: 'AMD',
          data: amdData,
          color:'#ffb9b9',
          borderWidth: 0,
        }, {
          name: 'Intel',
          data: intelData,
          color:'#c7e0ff',
          borderWidth: 0,
        },{
          name: 'Apple',
          data: appleData,
          color:'#666666',
          borderWidth: 0,
        } ]
      }
      self.priceBandsProcessorGraphs.push(obj)
    },
    renderPriceBandGraphs(d,i){
      let self = this
      let category = []
      let series = []
      self.priceBandData[i].data = {}
      let bandKeys = ['<$400','$400-$600','$600-$800','>$800']
      if(d.data.length)
      {
        for (let [idx, dataset] of bandKeys.entries()) 
          series.push({name:dataset.replace(/\$/g,self.websitesPriceMap[self.selected_website]),customKey:dataset,data:[],customCount:[],tooltip: {valueSuffix: '%'}})
        for (let [idx, dataset] of series.entries())
          for (let [idx2, dataset2] of d.data.entries()) 
          {
            category.push('Page ' + dataset2.page + '<br/>Total AMD ' + self.deviceMapper[self.device] + ': ' + dataset2.count )
            dataset.data.push({y:dataset2.price_bands[dataset.customKey].sov,count:dataset2.price_bands[dataset.customKey].count})  
          }
                 
        self.priceBandData[i].data  = {
            chart: {
            type: 'line',
            height:230
          },
          title: {
              text: ''
          },
          subtitle: {
              verticalAlign:'bottom',
              text: ''
          },
          xAxis: {
              categories: category,
              title: {
                  text: null
              }
          },
          plotOptions: {
              line: {
               
                  marker: {
                      enabled: true
                  },
          
                  dataLabels: {
                      enabled: true,
                        allowOverlap:true,
                      style:{fontWeight:0},
                      formatter:function(){ 
                        return this.point.y + '%'
                      },
                  }
              }
          },
          yAxis: {
              min: 0,
              title: {
                  text: '',
              },
          },
          tooltip: {
            formatter: function() {
              var mytooltip = this.points[0].key.slice(0,6) + '<br/>' ;
              for(var i = 0;i<this.points.length;i++)
              {
                mytooltip += this.points[i].series.name
                mytooltip += ':<b> ' + self.format(this.points[i].y) + '% (' + this.points[i].point.count + ')<br/>' ; 
              }
              return mytooltip;
            },
            shared: true
          },
        
          legend: {
              enabled:true,
              labelFormatter: function () {
                return this.name ;
            }
          },
          credits: {
              enabled: false
          },
          series: series
        }
     }
    },
    getPriceBands(){
      let self = this
      self.loader = true
      for (let [idx, dataset] of Object.entries(self.priceBandData))
      {
        self.priceBandResponse[idx] = []
        
        let payload = {
          "website": this.selected_website,
          "item_category":self.device,
          "start_date": moment(dataset.start_date).format('YYYY-MM-DD'),
          "end_date": moment(dataset.end_date).format('YYYY-MM-DD')
        }
        const url = "/api/websites/price_bands"
        self.$http.post(url, payload ).then(response => {
          self.priceBandResponse[idx] = response.body.data
          self.renderPriceBandGraphs(response.body,idx)
          self.loader = false
        }, err => {
          self.loader = false
        });


      }
      
    },
    drawDailyPagePosition(d){
      let self = this
      let categories = []
      let dataPage1 = []
      let dataPage2 = []
      let dataPage3 = []
      let laptop_count = 0
      for(let [idx, dataset] of d.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        dataPage1.push(dataset.data[1])
        dataPage2.push(dataset.data[2])
        dataPage3.push(dataset.data[3])
      }
      let obj = {}
      self.daywisePositionChart = {      
        chart: {
            type: 'column',
            height: 320
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: categories
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
              text: ''
          },
      },        
        tooltip: {
           enabled: false,
    
        },
        plotOptions: {
            column: {
                stacking: 'percent',
                dataLabels: {
                  enabled: true,
                  useHTML: true,
                  zIndex:0,
                  formatter: function() {
                    
                    return  '<span style="color:white;font-size:10px;font-weight:normal;background-color:#00000085;padding:4px">' +self.format(Number(this.point.percentage.toFixed())) + '% </span>'
                },
               }
            }
        },
        series: [{
            name: 'Page 1',
            data: dataPage1,
            color:'#00800080',
            borderWidth: 0,
        }, {
            name: 'Page 2',
            data: dataPage2,
            color:'#ffa5008a',
            borderWidth: 0,
        },{
            name: 'Page 3',
            data: dataPage3,
            color:'#ff00008a',
            borderWidth: 0,
        } ]
      }
    },
    drawDailyAMDCount(d){
      let self = this
      let categories = []
      let data = []
      let data2 = []
      let data3 = []
      let laptop_count = 0
      for(let [idx, dataset] of d.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        data.push(dataset.amd_count)
        data2.push(dataset.all_count)
        data3.push(dataset.sov)
      }
      self.daywiseAMDCount = {
            chart: {
            type: 'line',
            height:230,
            inverted:false,
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
       
        yAxis: [{
            min: 0,
            title: { text: 'Count' },
        },  
        {
            min: 0,
            title: { text: 'AMD SOS' },
            opposite: false
        }],
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + '<br/>';
            for(var i = 0;i<this.points.length;i++)
            {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y);
              if(this.points[i].series.name.indexOf('SOS')!=-1)
                mytooltip += '%'
              mytooltip += '</b><br/>'
            }
            return mytooltip;
          },
          shared: true
        },
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [{
          name: 'AMD ' + self.deviceMapper[self.device],
          data: data,
          zIndex:9,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'All '+ self.deviceMapper[self.device],
          data: data2,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'AMD SOS',
          data: data3,
          yAxis: 1,  
          type:'line',
          pointWidth: 1,
          color: '#fb7878', 
        }]
      }
    },
    drawDailyAMDCountAverage(d){
      let self = this
      let categories = []
      let data = []
      let data2 = []
      let data3 = []
      let laptop_count = 0
      for(let [idx, dataset] of d.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        data.push(dataset.amd_count)
        data2.push(dataset.all_count)
        data3.push(dataset.sov)
      }
      self.daywiseAMDCountAverage = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
       
        yAxis: [{
            min: 0,
            title: { text: 'Count' },
        },  
        {
            min: 0,
            title: { text: 'AMD SOS' },
            opposite: false
        }],
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + '<br/>';
            for(var i = 0;i<this.points.length;i++)
            {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y);
              if(this.points[i].series.name.indexOf('SOS')!=-1)
                mytooltip += '%'
              mytooltip += '</b><br/>'
            }
            return mytooltip;
          },
          shared: true
        },
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [{
          name: 'AMD ' + self.deviceMapper[self.device],
          data: data,
          zIndex:9,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'All '+ self.deviceMapper[self.device],
          data: data2,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'AMD SOS',
          data: data3,
          yAxis: 1,  
          type:'line',
          pointWidth: 1,
          color: '#fb7878', 
        }]
      }
    },
    drawDailyAMDCountGaming(d){
      let self = this
      let categories = []
      let data = []
      let data2 = []
      let data3 = []
      let laptop_count = 0
      for(let [idx, dataset] of d.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        data.push(dataset.amd_count)
        data2.push(dataset.all_count)
        data3.push(dataset.sov)
      }
      self.daywiseAMDCountGaming = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
       
        yAxis: [{
            min: 0,
            title: { text: 'Count' },
        },  
        {
            min: 0,
            title: { text: 'AMD SOS' },
            opposite: false
        }],
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + '<br/>';
            for(var i = 0;i<this.points.length;i++)
            {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y);
              if(this.points[i].series.name.indexOf('SOS')!=-1)
                mytooltip += '%'
              mytooltip += '</b><br/>'
            }
            return mytooltip;
          },
          shared: true
        },
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [{
          name: 'AMD ' + self.deviceMapper[self.device],
          data: data,
          zIndex:9,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'All '+ self.deviceMapper[self.device],
          data: data2,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'AMD SOS',
          data: data3,
          yAxis: 1,  
          type:'line',
          pointWidth: 1,
          color: '#fb7878', 
        }]
      }
    },
    drawDailyChartAveragePage13(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      for(let [idx, dataset] of this.dailyDataAveragePage13.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = dataset.page_count
        let ryzensov = Number(dataset.ryzen_sov)
        let nonryzensov = Number(dataset.non_ryzen_sov)
        data3.push(ryzensov)
        data4.push(nonryzensov)
        amdSov.push(Number(dataset.amd_sov))
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      let obj = {}
      self.daywiseChartAverage = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total ' + self.deviceMapper[self.device]  + ': '+laptop_count
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                     allowOverlap:true,
                    style:{fontWeight:0},
                    
                    formatter:function(){ 
                      let category = this.point.category
                      let plotY = this.point.plotY
                      if(obj.hasOwnProperty(category))
                        obj[category].push(plotY)
                      else
                      {
                        obj[category] = []
                          obj[category].push(plotY)
                      }  
                      let plotYPos = obj[category].indexOf(plotY)
                      let prvPlotY = obj[category][plotYPos-1]
                      if( plotYPos > 0)
                      {
                        if((plotY - prvPlotY < 9) && (plotY - prvPlotY > -9))
                        {
                          this.point.plotY = this.point.plotY + 9
                          obj[category][plotYPos] = this.point.plotY
                        }
                      }
                      let d = this.series.userOptions.detail[this.point.index]
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'AMD SOV',
            data: amdSov,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        },{
            name: 'Ryzen SOV',
            data: data3,
            color: '#ffa500a8',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail1
        }, {
            name: 'Non-Ryzen SOV',
            data: data4,
            color: 'grey',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail2
        }]
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    drawDailyChartGamingPage13(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      for(let [idx, dataset] of this.dailyDataGamingPage13.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = dataset.page_count
        let ryzensov = Number(dataset.ryzen_sov)
        let nonryzensov = Number(dataset.non_ryzen_sov)
        data3.push(ryzensov)
        data4.push(nonryzensov)
        amdSov.push(Number(dataset.amd_sov))
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      let obj = {}
      self.daywiseChartGaming = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total ' + self.deviceMapper[self.device]  + ': '+laptop_count
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                     allowOverlap:true,
                    style:{fontWeight:0},
                    
                    formatter:function(){ 
                      let category = this.point.category
                      let plotY = this.point.plotY
                      if(obj.hasOwnProperty(category))
                        obj[category].push(plotY)
                      else
                      {
                        obj[category] = []
                          obj[category].push(plotY)
                      }  
                      let plotYPos = obj[category].indexOf(plotY)
                      let prvPlotY = obj[category][plotYPos-1]
                      if( plotYPos > 0)
                      {
                        if((plotY - prvPlotY < 9) && (plotY - prvPlotY > -9))
                        {
                          this.point.plotY = this.point.plotY + 9
                          obj[category][plotYPos] = this.point.plotY
                        }
                      }
                      let d = this.series.userOptions.detail[this.point.index]
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'AMD SOV',
            data: amdSov,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        },{
            name: 'Ryzen SOV',
            data: data3,
            color: '#ffa500a8',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail1
        }, {
            name: 'Non-Ryzen SOV',
            data: data4,
            color: 'grey',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail2
        }]
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    removeRatingFilter(){
      this.ratingInput1 = ''
      this.ratingInput2 = ''
      if(localStorage.ratingExp) delete localStorage.ratingExp
      if(localStorage.ratingInput1) delete localStorage.ratingInput1
      if(localStorage.ratingInput2) delete localStorage.ratingInput2
      this.changeFilter()
    },
    applyRatingFilter(){
      let self = this
      if(self.ratingInput1 > 5 )
      {
        alert('Rating value should be between 0 and 5')
        return false
      }
      if(self.ratingInput1 < 0 )
      {
        alert('Rating value should be between 0 and 5')
        return false
      }
      if(self.ratingExp =='between')
      {
        if(self.ratingInput2 > 5  )
        {
          alert('Rating value should be between 0 and 5')
          return false
        }
        if(self.ratingInput2 < 0  )
        {
          alert('Rating value should be between 0 and 5')
          return false
        }
      }
      self.changeFilter()
    },
    goToDetailPageOEM(){
      window.location = '#/sov-detailed-demo-oem'

    },
    goToSovDetailNew(){
      window.location = '#/sovdetailed-demo-new'
    },
    getClassSOVSOS(){
      if(this.websiteSOSGraphs.length == 1) return 'col-md-12'
      if(this.websiteSOSGraphs.length == 2) return 'col-md-6 mycols'
      if(this.websiteSOSGraphs.length == 3) return 'col-md-4 mycols'
      if(this.websiteSOSGraphs.length >= 4) return 'col-md-4 mycols'
    },
    siteChange(){
      this.date.startDate = moment().subtract(1,'days').format('YYYY-MM-DD')
      this.date.endDate = moment().subtract(1,'days').format('YYYY-MM-DD')
      this.device = 'laptop'
      this.sovStartDate = moment(this.date.endDate).subtract(1,'week').format('YYYY-MM-DD')
      this.sovEndDate = this.date.endDate
      this.processDisablingDates() 
      this.refresh()
    },
    newTrendSOVSOS(){
      let self = this
      const url = "/api/amazon_india/website_sov_sos_trend_india"
      let payload = {}
      self.daywiseChartOEM = []
      payload["website"] = [self.selected_website]
      payload["start_date"] = moment(self.sovStartDate).format('YYYY-MM-DD')
      payload["end_date"] = moment(self.sovEndDate).format('YYYY-MM-DD')
      payload["interval"] = self.sovIntervalOEM
      payload["item_category"] = self.device
      payload["segment"] = "consumer"
      self.$http.post(url, payload).then(response => {
        self.drawDailyChartOEM(response.body)
      }, err => {
      });
    },

    newSOVSOS(){
      let self = this
      const url = "/api/amazon_india/sov_sos_india"
      let payload = {}
      payload["website"] = [self.selected_website]
      payload["timestamp"] = self.date.endDate
      payload["item_category"] = self.device
      payload["segment"] = "consumer"
      self.websiteSOSGraphs = []
      self.$http.post(url, payload).then(response => {
        self.drawWebSOSGraphs(response.body)
      }, err => {
      });
    },
    processComplianceTrendData(data){
      let self = this
      let obj = {
        id:"complianceTrend",
        xAxis: [],
        seriesData: [
          {
            name: self.websitesUrls3[self.selected_website],
            data: []
          }  
        ]
      }
      for (let [idx, dataset] of data.data.entries()) 
      {
        obj.xAxis.push( moment(dataset.timestamp).format('MMM DD, YY'))
        obj.seriesData[0].data.push(dataset.final_complaince_score)
      }
      self.complianceTrend.push(obj)
    
    },
    getComplianceTrend(){
      let self = this
      self.complianceTrend = []
      self.loader = true
      let payload = {
        "website": self.selected_website,
        "start_date": moment(self.comTrendStartDate).format('YYYY-MM-DD'),
        "end_date": moment(self.comTrendEndDate).format('YYYY-MM-DD'),
        "item_category": self.device,
        "segment": "consumer"
      }
      const url = "/api/amazon_india/compliane_timeline_india"
      self.$http.post(url, payload ).then(response => {
        if(response.data.data.length) self.processComplianceTrendData(response.data)
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    orderAxis(uo_xaxis){
      let keylist = ['brand','consumer','commercial']
      let arr = []
      for (let [k, v] of keylist.entries())
      {
        for(let [idx, dataset] of uo_xaxis.sort().entries()) 
        {
          if(dataset.indexOf(v)!=-1)
          {
            arr.push(dataset)
          }
        }
      }
      return arr
    },
    getComData(){
      let self = this
      self.loader = true
      self.activeComChart = false
      let payload = {}
      payload["timestamp"] = self.date.startDate
      payload["item_category"] = self.device
      let url = "/api/amazon_india/compliance_score"
      if(this.retail_websites.includes(this.selected_website))
        url = "/api/websites/compliance_score" 
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.drawComChart(response.body.data)
      }, err => {
        self.loader = false
      });
      
    },
    drawComChart(d){
      let self = this
     
      let categories = []
      let data1 = []
      let arr = []
      let highlight_color = ''
      let sumFinalScore = 0
      self.selectedWebComplianceScore = ''
      for(let [idx, dataset] of Object.entries(d)) 
      {
        if(self.selected_website == idx )
        {
          self.selectedWebComplianceScore = dataset.final_complaince_score
          arr.push({url:idx,data:dataset.final_complaince_score,total:dataset.total_count})
        }
        else if (self.selected_website == 'all')
        {
          sumFinalScore += dataset.final_complaince_score
        }
        
      }
      if (self.selected_website == 'all')
      {
        self.selectedWebComplianceScore = Number(sumFinalScore/Object.keys(d).length).toFixed()
      }
      
      let sortedArr =  arr.sort((a, b) =>  a.data - b.data);
      let newsortedArr = []
      for(let [idx, dataset] of sortedArr.entries())
      {
        if(self.oem_websites.includes(self.selected_website))
        {
          if(self.oem_websites.includes(dataset.url))
            newsortedArr.push(dataset)
        }
        else
        {
          if(!self.oem_websites.includes(dataset.url))
            newsortedArr.push(dataset)
        }
      }
      for(let [idx, dataset] of newsortedArr.entries())
      {
        if(newsortedArr.length == 1)
          categories.push(self.websitesUrls3[dataset.url])
        else
        {
          if(idx==0)
            categories.push(self.websitesUrls3[dataset.url]+'<br/> <b>(Least Compliant)</b>')
          else if(idx == newsortedArr.length-1)
            categories.push(self.websitesUrls3[dataset.url]+'<br/> <b>(Most Compliant)</b>')
          else
            categories.push(self.websitesUrls3[dataset.url])
        }
        if(self.selected_website == dataset.url)
          highlight_color = '#6a2798'
        else
          highlight_color = '#8a87e8'
        data1.push({'y':dataset.data,color:highlight_color})
      }
      let plotLine = []
      plotLine.push({ color: 'black', width: 1, value: 85, dashStyle: 'shortdash', zIndex: 4, label: { text: 85 } }) //static lin at 85 
      self.comChart = {
            chart: {
            type: 'column',
            height:230,
            marginTop: 45
        },
        title: {
            text: ' '
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: 'Websites'
            }
        },
        plotOptions: {
            column: {
              dataLabels: {
                  enabled: true,
                  style:{fontWeight:0},
                  formatter:function(){
                    return this.point.y   
                  },
              }
            }
        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: 'Compliance Score',
      
            },
            plotLines: plotLine,
        },
        tooltip: {
          shared:true,
          enabled: false
        },
      
        legend: {
            enabled:false
        },
        credits: {
            enabled: false
        },
        series: [{
            name: '',
            data: data1,
            // color: '#8a87e8',
            pointWidth: 60,
            dataSorting: {
                enabled: true
            },
            
        }]
      }
      setTimeout(function(){
        self.activeComChart = true
      },0)
    },
    drawDailyChartOEM(d){
      let self = this
      let sovsosmapper = {
        'sov_data': 'SOV',
        'sos_data': 'SOS'
      }
      for (let [so_i, so_d] of ['sov_data','sos_data'].entries())
      {
        for (let [eachSo_i, eachSo_d] of d[so_d].entries())
        {
          let obj = {}
          let categories = []
          for(let [idx, dataset] of eachSo_d.trend.entries()) 
          {  
            categories.push(self.formatDate('sovIntervalOEM',dataset.timestamp))
            for(let [idx2, dataset2] of dataset.data.entries()) 
            {
              let name = dataset2.processor.replace('amd','AMD') + ' ' + dataset2.segment
              if(obj.hasOwnProperty(name))
              {
                obj[name].push( {y:Math.round(dataset2.sov),count:dataset2.count,total:dataset2.total_count} )
              }
              else
              {
                obj[name] = []
                obj[name].push( {y:Math.round(dataset2.sov),count:dataset2.count,total:dataset2.total_count} )
              }
            }
          }
          let keylist = ['brand','consumer','commercial']
          for (let [k, v] of keylist.entries())
          {
            let seriesData = []
            for(let [idx, dataset] of Object.entries(obj))
            {
              if(idx.indexOf(v)!=-1)
              {
                seriesData.push({name:idx,data:dataset,tooltip: {valueSuffix: '%'}})
              }
            }
            if(seriesData.length)
            {
                let sovsosobj = {}
                sovsosobj.title = eachSo_d.label.toUpperCase() + ' ' + v.toUpperCase() + ' ' +   sovsosmapper[so_d] 
                sovsosobj.chart = {
                  chart: {
                    type: 'line',
                    height:230
                  },
                  title: {
                    text: ''
                  },
                  subtitle: {
                    verticalAlign:'bottom',
                    text: ''
                  },
                  xAxis: {
                    categories: categories,
                    title: {
                      text: null
                    }
                  },
                  plotOptions: {
                      line: {
                          dataLabels: {
                              enabled: true,
                                allowOverlap:true,
                              style:{fontWeight:0},
                              formatter:function(){ 
                                return this.point.y + '%'
                              },
                          }
                      }
                  },
                  yAxis: {
                      min: 0,
                      title: {
                          text: '',
                
                      },
                  },
                  tooltip: {
                    shared:true
                  },
                
                  legend: {
                      enabled:true
                  },
                  credits: {
                      enabled: false
                  },
                  series: seriesData
                }
                self.daywiseChartOEM.push(sovsosobj)

            }
          
          }
        }  
      }
    },
    drawWebSOSGraphs(d)
    {
      let self = this
      let max = 0
      for (let [so_i, so_d] of ['sov_data','sos_data'].entries())
      {
        for (let [eachSo_i, eachSo_d] of d[so_d].entries())
        {
          let sovsosobj = {}
          sovsosobj.title = 'AMD Vs Intel ' + self.deviceMapper[self.device] + ' ' + eachSo_d.label.toUpperCase() 
          let uo_xaxis = []
          let o_xaxis = []
          let data = []
          let obj = {}
          let max = 0
          let total = ''
          for (let [idx, dataset] of eachSo_d.data.entries())
          {
            let name = dataset.processor.replace('amd','AMD') + ' ' + dataset.segment
            uo_xaxis.push(name)
            let val = Math.round(dataset.sov)
            obj[name] = val
            if(dataset.sov > max) max = dataset.sov + 5 
            if(dataset.segment == 'consumer') total = dataset.total_count
            if(dataset.segment == 'commercial') total = dataset.total_count
          }
          o_xaxis = self.orderAxis(uo_xaxis)
          for (let [idx, dataset] of o_xaxis.entries())
          {
            data.push(obj[dataset])
          }
          sovsosobj.chart = 
          {
            credits: {
              enabled: false
            },
            chart: {
              type:'column',
              height:320,
              inverted:true
            },
            title: {
              text: ''
            },
            subtitle: {
                align:'left',
                text: 'Total ' + self.deviceMapper[self.device] + ': ' + total
            },

            yAxis: {
                title: {
                    text: ''
                },
                max: max,
                tickInterval: 5,
            },
              plotOptions: {
              column: {
                  dataLabels: {
                      enabled: true,
                      color:'black',
                      
                      formatter:function(){
                          return this.point.y + '%' 
                      }
                  }
              }
            },
            xAxis:{
              categories: o_xaxis,
              crosshair: true,
            },
            legend:{enabled:false},
            tooltip: {
              formatter: function() {
                var mytooltip = this.points[0].key  ;
                for(var i = 0;i<this.points.length;i++)
                {
                  mytooltip += this.points[i].series.name
                  mytooltip += ':<b> ' + self.format(this.points[i].y) + '%'; 
                }
                return mytooltip;
              },
              shared: true
            },
            series: [ 
            {
              name:'',
              data:data,
              color:'#3368fa8c',
            }]
          }
          self.websiteSOSGraphs.push(sovsosobj) 
        } 
      }  
    },


    checkDeviceOption(){
      let hideDeviceOptionSites = ['https://www.amazon.in/gp/bestsellers','https://www.hp.com/in-en','https://www.hp.com/in-en#commercial'] 
      if (hideDeviceOptionSites.includes(this.selected_website)){
        return false
      }
      else { 
        return true
      } 
    },
    callAllAPI(){
      this.sov()
      this.website_details()
      this.ryzenVsNonRyzen()
      this.getDailyData()
      // this.getProducts()
      this.getPriceRankReview()
      this.old_website_details()
      this.getPriceTableData()
      this.getdailyCompareRyzen()
    },
    getBrandList(){
      let self = this
      self.brandLoader = true
      let url = '/api/amazon_india/brand_list_india'
      let payload = {
        "item_category": this.device,
        "start_date": this.date.startDate,
        "end_date": this.date.endDate,
        "website": [this.selected_website]
      }
      self.$http.post(url, payload).then(response => {
        self.brandListOptions = response.body.data.data
        self.callAllAPI()
        self.brandLoader = false
      }, err => {
        self.brandLoader = false
      });

    },
    getPriceRankReview(){
      let self = this
      self.loader4 = true
      const url = "/api/amazon_india/price_distribution_band"
      let payload = {}
      payload["website"] = self.selected_website
      payload["item_category"] = self.device
      payload["start_date"]  = self.date.startDate
      payload["end_date"]  = self.date.endDate
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
      self.$http.post(url, payload).then(response => {
        self.loader4 = false
        self.priceRankReview = response.body.data
      }, err => {
        self.loader4 = false
      });

    },
    getdailyCompareRyzen(){
      let self = this
      self.loader4 = true
      const url = "/api/amazon_india/get_ryzen_compare"
      let payload = {}
      payload["item_category"] = self.device
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
      payload["interval"] = self.sovInterval
      payload["start_date"] = moment(self.sovStartDate).format('YYYY-MM-DD')
      payload["end_date"] = moment(self.sovEndDate).format('YYYY-MM-DD')
      payload["website"] = self.selected_website
      self.$http.post(url, payload).then(response => {
        self.loader4 = false
        self.drawDailyChartCompareRyzen(response.body.data.data)
      }, err => {
        self.loader4 = false
      });
    },
    getPriceTableData(){
      let self = this
      self.loader = true
      self.priceTableData.header = []
      self.priceTableData.data = []
      self.priceProcessorPie = []
      let payload = {}
      payload["website"] = self.selected_website
      payload["item_category"] = self.device
      payload["start_date"]  = self.date.startDate
      payload["end_date"]  = self.date.endDate
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
      const url = self.priceAPIMapper[self.device]
      self.$http.post(url, payload).then(response => {
        self.loader = false
        let resp = response.body
        if(!resp.data.hasOwnProperty('data')) return
        self.priceTableData.header = resp.data.headers
        self.priceTableData.data = resp.data.data
        self.processPricePieChart()
      }, err => {
        self.loader = false
      });

    },
    getPriceBandSeries(){
      let self = this
      let seriesData = []
      self.selectedPriceRange = ''
      self.pricePieLabel['priceBandSOV'] = 'Price Band SOV'
      for (let [ii, dd] of self.priceTableData.data.entries()){
        if(dd.total_count > 0){
          if(self.selectedPriceRange == '') self.selectedPriceRange = dd.price_range
          seriesData.push({name:dd.price_range,y:dd.total_count})
        } 
      }
      return seriesData
    },
    getCPUSeries(){
      let self = this
      let seriesData = []
      for (let [ii, dd] of self.priceTableData.data.entries()){
        if(dd.price_range == self.selectedPriceRange)
        {
          self.pricePieLabel['cpu'] = 'Processors in ' + self.selectedPriceRange  + ' Band'
          if(dd.amd > 0) seriesData.push({y:dd.amd,name:'AMD',color:'#f47778'})
          if(dd.intel > 0) seriesData.push({y:dd.intel,name:'Intel',color:'#78b2fb'})
        }
      }
      if (seriesData.length) self.selectedCPU = seriesData[0].name
      return seriesData
    },
    getCPUModelSeries(){
      let self = this
      self.pricePieLabel['cpuModel'] = 'Processor Models in ' + self.selectedPriceRange  + ' Band'
      let colorIdx1 = 0
      let colorIdx2 = 0
      let keys = []
      for (let [ii, dd] of Object.keys(self.priceTableData.data[0]).entries()){ 
        if((dd.includes('amd_') || dd.includes('intel_') ) && (!dd.includes('brand')))
        {
          let newObj = {key:dd,label:dd.replace(/_/g,' ').toUpperCase()}
          if(dd.includes('amd')) 
          {
            newObj.color = this.colorShades.red[colorIdx1]
            if(colorIdx1==this.colorShades.red.length-1) colorIdx1 = 0
            else colorIdx1++
          }
          else
          {
            newObj.color = this.colorShades.blue[colorIdx2]
            if(colorIdx2==this.colorShades.red.length-1) colorIdx2 = 0
            else colorIdx2++
          }
         
          keys.push(newObj)

        }
      }
      
      let seriesData = []
      for (let [ii, dd] of self.priceTableData.data.entries()){
        if(dd.price_range == self.selectedPriceRange)
        {
          for (let [i, d] of keys.entries())
          {
            if(dd[d.key]!=0)
              seriesData.push({y:dd[d.key],name:d.label,color:d.color,custKey:d.key})
          }
        }
      }
      if (seriesData.length) 
      {
        self.selectedCPUModelLabel = seriesData[0].name
        self.selectedCPUModelKey = seriesData[0].custKey
      }
      return seriesData
    },
    getBrandPriceSeries(){
      let self = this
      let brandCount = {}
      self.pricePieLabel['brand'] = 'Brands in ' + self.selectedPriceRange  + ' Band'
      let colorMapper= {
        'lenovo': '#e60012',
        'avita': '#704092',
        'asus': '#00539b',
        'acer': '#83B81A',
        'hp': '#0096D6',
        'mi': '#fd4900',
        'dell': '#3287c1',
      }
      let colorIdx1 = 0
      let colorIdx2 = 0
      let keys = []
      for (let [ii, dd] of Object.keys(self.priceTableData.data[0]).entries()){ 
        if((dd.includes('amd_') || dd.includes('intel_') ) && (!dd.includes('brand')))
        {
          let newObj = {key:dd,label:dd.replace(/_/g,' ').toUpperCase()}
          if(dd.includes('amd')) 
          {
            newObj.color = this.colorShades.red[colorIdx1]
            if(colorIdx1==this.colorShades.red.length-1) colorIdx1 = 0
            else colorIdx1++
          }
          else
          {
            newObj.color = this.colorShades.blue[colorIdx2]
            if(colorIdx2==this.colorShades.red.length-1) colorIdx2 = 0
            else colorIdx2++
          }
    
          keys.push(newObj)

        }
      }
      let seriesData = []
      for (let [ii, dd] of self.priceTableData.data.entries()){
        if(dd.price_range == self.selectedPriceRange)
        {
          for (let [i1, d1] of keys.entries()){
            let desireddataset = dd[d1.key + '_brand']
            for (let [i, d] of desireddataset.entries()){
              if(d.value>0) {
                if(!brandCount.hasOwnProperty(d.key)) brandCount[d.key] = d.value
                else brandCount[d.key] = brandCount[d.key] + d.value
              }
            }
          }  
        }
      }
      for(let [i, d] of Object.entries(brandCount))
      {
        let newObj = { y: d, name: i }
        if(colorMapper.hasOwnProperty(i)) newObj.color = colorMapper[i]
        seriesData.push(newObj)
      }
      return seriesData
    },
    processPricePieChart(){
      let self = this
      self.priceProcessorPie = [
        { key: 'priceBandSOV', chart: {},  margin: [20,0,0,0], fontSize: 10 },
        { key: 'cpu', chart: {} , margin: [20,0,0 ,0], fontSize: 12 },
        { key: 'cpuModel', chart: {}, margin: [20,0,0,0], fontSize: 10  },
        { key: 'brand', chart: {}, margin: [20,0,0,0], fontSize: 12  },
      ]
      for (let [idx, dataset] of self.priceProcessorPie.entries()){
        self.renderPricePieChart(idx,dataset)
      }
    },
    renderPricePieChart(idx,dataset){
      let self = this
      let seriesData = []
      if(dataset.key=='priceBandSOV') seriesData = self.getPriceBandSeries()
      else if(dataset.key=='cpu') seriesData = self.getCPUSeries()
      else if(dataset.key=='cpuModel') seriesData = self.getCPUModelSeries()
      else if(dataset.key=='brand') seriesData = self.getBrandPriceSeries()
      dataset.chart = {
          chart: {
            margin: dataset.margin,
            padding:[0,0,0,0]   ,
            backgroundColor: 'transparent' 
          },
          title: {  
              text:  '',
          },
          credits: {
            enabled: false
          },
          accessibility: {
            point: {
                valueSuffix: '%'
            }
          },
          tooltip: {
            formatter(){
              var mytooltip = ''
              mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
              mytooltip += this.point.name
              mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
              mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
              return mytooltip;             
            },
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              cursor: 'pointer',
              events: {
                click: function (event) {
                  // if(dataset.key=='priceBandSOV') self.selectedPriceRange = event.point.name
                  // else if(dataset.key=='cpu') self.selectedCPU = event.point.name
                  // else if(dataset.key=='cpuModel') {
                  //   self.selectedCPUModelKey = event.point.custKey
                  //   self.selectedCPUModelLabel = event.point.name
                  // }
                  // else return
                  if(dataset.key!='priceBandSOV') return
                  self.selectedPriceRange = event.point.name
                  for (let [ii, rr] of self.priceProcessorPie.entries()) {
                    if(ii>idx) {
                      rr.chart = {}
                      self.renderPricePieChart(ii,rr)
                    }  
                  }
                }
              } 
            },
            pie: {
              dataLabels: {
                enabled: true,
                useHTML: true,
                formatter: function() {
                  if (this.point.percentage > 0)  
                    return  '<span style="color:white;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                },
                distance: -25,
                style: {
                  fontSize: 11,
                }  
              },
              showInLegend: true,
              size: '80%'
            }
          },
          legend:{
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'top',
            borderWidth:1,
            borderColor:'silver',
            itemStyle: {
              fontSize: dataset.fontSize,
              fontWeight: 0,
              color:this.$parent.darkMode ? 'white' : '#666666'
            },
            maxHeight:65,
          },  
          series: [{  
            type: 'pie',
            data: seriesData
          }]
        }
    },
    old_amdVIntelPriceGraph(){
      let self = this
      let processors = {
        "price": {},
        "count": {},
      }
      self.old_amdVIntelPriceGraphData = []
      for(let [idx, dataset] of this.oldWebsiteData.entries()) 
      {
        if ((self.selectedPage == 1) && (dataset.page!=1)) continue
        if(dataset.processor=="" || dataset.processor==" " ) dataset.processor = "N/A"
        processors.price[dataset.processor] = []
        if (isNaN(processors.count[dataset.processor]))
          processors.count[dataset.processor] = 1
        else  
          processors.count[dataset.processor]++
      }

      for(let [idx, dataset] of this.oldWebsiteData.entries()) 
      {
        if ((self.selectedPage == 1) && (dataset.page!=1)) continue
        if(dataset.processor=="" || dataset.processor==" " ) dataset.processor = "N/A"
        let price = dataset.price.replace('₹','')
        price = price.replace(" ",'')
        price = price.replace(",",'')
        price = price.replace(",",'')
        if(price>0)
          processors.price[dataset.processor].push(Number(price))
      }
      let category = []
      let data = []
      for(let [i, d] of Object.entries(processors.price))
      {
        category.push(i)
        data.push([Math.min(...d),Math.max(...d)])
      }
      let symbol = '₹' 
      let chart =  {
        chart: {
          type: 'columnrange',
          inverted: true,
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
          gridLineWidth:1,
          categories:  category,
          labels:{
              style:{color:this.$parent.darkMode ? 'white' : '#666666'}
            },
          title: {
            text: 'Processors'
          },
          min:0,
          gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6' ,
        },
        yAxis: {
          title: {
            text: 'Price'
          },
          gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6' ,
          min:0,
        },
        tooltip: {
          formatter(){
           
            var mytooltip = this.point.category + '<br/>'
            mytooltip += 'Count: '
            mytooltip += '<b>' + processors.count[this.point.category] + '</b><br/>'
            mytooltip += this.point.series.name
            mytooltip += ' : <b> ' + symbol + self.format(this.point.low) +  ' - '+ symbol + self.format(this.point.high)  +  '</b> <br/>' 
            return mytooltip;             
          },
        },
        plotOptions: {
          series: {
            minPointLength: 2
          }, 
          columnrange: {
              dataLabels: {
                  enabled: true,
                  color:this.$parent.darkMode ? 'white' : '#666666',
                  format: symbol + '{y}',
                  style: {
                    fontWeight:1
                  }
              }
          }
        },
        legend: {
            enabled: false,
            itemStyle:{color:this.$parent.darkMode ? 'white' : '#666666'}
        },
        series: [{
          name: 'Price Range',
          data: data
        }]
      }
      self.old_amdVIntelPriceGraphData.push({chart:chart})

      setTimeout(function(){
        self.old_activeAmdIntelGraph = true
      },500)
    },
    old_processorPie(pieData){
      let self = this
      let seriesData = []
      for(let [idx2, dataset2] of Object.entries(pieData))
      {
        let obj = {}
        obj['name'] = idx2
        obj['y'] = dataset2
        seriesData.push(obj)    
      } 
      this.old_processorPieGraph = {
        chart: {
          margin: [80,0,35,0],
          padding:[0,0,0,0]
          
        },
        title: {  
            text: '',
            verticalAlign:'bottom'
        },
        credits: {
          enabled: false
        },
        accessibility: {
          point: {
              valueSuffix: '%'
          }
        },
        tooltip: {
          formatter(){
            var mytooltip = ''
            mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
            mytooltip += this.point.name
            mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage)  + '%)</b> <br/>'
            mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
            return mytooltip;             
          },
        },
        plotOptions: {
            series: {
                borderWidth: 0,
            },
            pie: {
                dataLabels: {
                  enabled: true,
                  distance: -15,
                  format: '{point.percentage:.1f} %',
                  style: {
                    fontSize: 10,
                  }  
                },
                showInLegend: true,
                size: '100%'
            }
        },
        legend:{
          align: 'center',
          layout: 'horizontal',
          verticalAlign: 'top',
          itemStyle: {
            fontSize: 11,
            fontWeight: 1,
            color:this.$parent.darkMode ? 'white' : '#666666'
          },
          maxHeight: 65, 
        },  
        series: [{  
          type: 'pie',
          data: seriesData
        }]
      } 
    },
   
    old_readyBarGraph(){
      let self = this
      let cpuPrice = {}
      self.old_barGraph = []
      for(let [i, d] of Object.entries(this.old_count.processor_type))
      {
        if (i!='N/A')
          cpuPrice[i] = []

      }
      for(let [idx, dataset] of this.oldWebsiteData.entries()) 
      {
        if ((self.selectedPage == 1) && (dataset.page!=1)) continue
        let cpu = dataset.processor_type
        if (dataset.processor_type=="" || dataset.processor_type==" " ||  dataset.processor_type=="N/A")
          continue
        let price = dataset.price.replace('₹','')
        price = price.replace(" ",'')
        price = price.replace(",",'')
        price = price.replace(",",'')  
        if(price>0)
          cpuPrice[cpu].push(Number(price))
      }
      let category = []
      let data = []
      for(let [i, d] of Object.entries(cpuPrice))
      {
        category.push(i.replace('amd','AMD'))
        data.push([Math.min(...d),Math.max(...d)])
      }
      let symbol = '₹'
     
      let chart =  {
        chart: {
          type: 'columnrange',
          inverted: true,
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
          gridLineWidth:1,
          categories: category,
          labels:{
              style:{color:this.$parent.darkMode ? 'white' : '#666666'}
            },
          title: {
            text: 'Processors'
          },
          min:0,
          gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6' ,
        },
        yAxis: {
          title: {
            text: 'Price'
          },
          min:0,
          gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6' 
        },
        tooltip: {
          formatter(){
        
            var mytooltip = this.point.category + '<br/>'
            mytooltip += 'Count: '
            mytooltip += '<b>' + self.old_count.processor_type[this.point.category] + '</b><br/>'
            mytooltip += this.point.series.name
            mytooltip += ' : <b> ' + symbol + self.format(this.point.low) +  ' - '+ symbol + self.format(this.point.high)  +  '</b> <br/>'
           
            return mytooltip;             
          },
        },
        plotOptions: {
          series: {
            minPointLength: 2
          }, 
          columnrange: {
              dataLabels: {
                  enabled: true,
                  color:this.$parent.darkMode ? 'white' : '#666666',
                  format: symbol + '{y}',
                  style: {
                    fontWeight:1
                  }
              }
          }
        },
        legend: {
            enabled: false,
            itemStyle:{color:this.$parent.darkMode ? 'white' : '#666666'}
        },
        series: [{
          name: 'Price Range',
          data: data
        }]
      }
      self.old_barGraph.push({chart:chart}) 
    },
    old_countIt(listingType,dataset){
      let self = this
      for(let [i, d] of Object.entries(this.old_labelMapper))
      {
        if(dataset[i]=="" || dataset[i]==" " ) dataset[i] = "N/A"
        if(dataset[i].indexOf('amd')!=-1) dataset[i] = dataset[i].replace('amd','AMD')
         if(dataset[i].indexOf('hp')!=-1) dataset[i] = dataset[i].replace('hp','HP')
         if(dataset[i].indexOf('lg')!=-1) dataset[i] = dataset[i].replace('lg','LG')
         if(dataset[i].indexOf('msi')!=-1) dataset[i] = dataset[i].replace('msi','MSI')
        if (isNaN(self[listingType][i][dataset[i]]))
          self[listingType][i][dataset[i]] = 1
        else  
          self[listingType][i][dataset[i]]++
      } 
    },
    old_generatePieCharts(listingType,chartKey){
      let self = this
      for(let [idx, dataset] of Object.entries(self[listingType])) 
      {
        let indx = 0
        let seriesData = []
        self.pieTotal = 0
        for(let [idx2, dataset2] of Object.entries(dataset))
        {
          let obj = {}
          obj['name'] = idx2
          obj['y'] = dataset2
          self.pieTotal  = dataset2 + self.pieTotal 
          obj['color'] = self.colorCodes[indx]
          seriesData.push(obj)    
          if(indx == self.colorCodes.length-1)
          {
            indx = 0
          }
          else
          {
            indx++
          }
        } 
        self[chartKey][idx] = {
          chart: {
            margin: [80,0,35,0],
            padding:[0,0,0,0]
           
          },
          title: {  
              text:  self.deviceMapper[self.device] +' Category Page ('+ self.selectedPage +') Distribution by ' + self.old_labelMapper[idx],
              verticalAlign:'bottom',
              style:{fontSize:13,color: this.$parent.darkMode ? 'white' : '#666666'}
          },
          credits: {
            enabled: false
          },
          accessibility: {
            point: {
                valueSuffix: '%'
            }
          },
          tooltip: {
            formatter(){
              var mytooltip = ''
              mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
              mytooltip += this.point.name
              mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
              mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
              return mytooltip;             
            },
          },
          plotOptions: {
              series: {
                  borderWidth: 0,
              },
              pie: {
                  dataLabels: {
                    enabled: true,
                    useHTML: true,
                    formatter: function() { 
                     
                      return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                    },
                    distance: -13,
                    style: {
                      fontSize: 11,
                    }  
                  },
                  showInLegend: true,
                  size: '100%'
              }
          },
          legend:{
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'top',
            itemStyle: {
              fontSize: 11,
              fontWeight: 1,
              color:this.$parent.darkMode ? 'white' : '#666666'
            },
            maxHeight: 65, 
          },  
          series: [{  
            type: 'pie',
            data: seriesData
          }]
        } 
        setTimeout(function(){
          self.old_activePie = true
        },50)
      }
    },
    old_readyPieCharts(){
      let self = this
      self.old_clearPieDataset()
      for(let [idx, dataset] of this.oldWebsiteData.entries()) 
      {
        if ((self.selectedPage == 1) && (dataset.page!=1)) continue
        self.old_countIt('old_count',dataset)
        if (dataset.processor == 'amd')
        {
          self.old_countIt('old_countAMD',dataset)
        }
      }
      self.old_generatePieCharts('old_count','old_pieChart')
      self.old_generatePieCharts('old_countAMD','old_pieChartAMD') 
    },
    old_clearPieDataset(){
      let self = this
      for(let [i, d] of Object.entries(this.old_labelMapper))
      {
        self.old_count[i] = {}
        self.old_countAMD[i] = {}
        self.old_pieChart[i] = {}
        self.old_pieChartAMD[i] = {}
      }
    },
    old_website_details(){
      let self = this
      self.loader = true
      let payload = {}
      payload["website"] = self.selected_website
      payload["item_category"] = self.device
      payload["start_date"]  = self.date.startDate
      payload["end_date"]  = self.date.endDate
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
      const url = "/api/amazon_india/website_detail_india"
      this.$http.post(url, payload).then(response => {
        this.oldWebsiteData = response.body.data
        self.loader = false
        self.$nextTick(function(){
          self.old_readyPieCharts()
          self.old_readyBarGraph()
          self.old_amdVIntelPriceGraph()
        }) 
      })  
    },
    checkChannel(){   
      if((this.selected_website == 'https://www.amazon.com') || (this.selected_website == 'https://www.harveynorman.com.au') || (this.selected_website == 'https://www.costco.com') || (this.selected_website == 'https://www.walmart.com') || (this.selected_website == 'https://www.bestbuy.com') || (this.selected_website == 'https://www.currys.co.uk'))
        {
          return true
        }
        else
        {
          return false
        }
    },
    changeFilter(){
      this.pickProduct = false
      this.selectedProduct = {key:'all'}
      localStorage.selected_product = JSON.stringify(this.selectedProduct)
      if(this.cpuFilter) localStorage.cpuFilter = this.cpuFilter 
      else delete localStorage.cpuFilter 
      if(this.brandFilter) localStorage.brandFilter = this.brandFilter 
      else delete localStorage.brandFilter
      if(this.ratingExp) localStorage.ratingExp = this.ratingExp
      else delete localStorage.ratingExp
      if(this.ratingInput1) localStorage.ratingInput1 = this.ratingInput1 
      else delete localStorage.ratingInput1
      if(this.ratingInput2) localStorage.ratingInput2 = this.ratingInput2
      else delete localStorage.ratingInput2
      if(this.fourKSeries) localStorage.fourKSeries = JSON.stringify(this.fourKSeries) 
      else delete localStorage.fourKSeries 
      if(this.fiveKSeries) localStorage.fiveKSeries = JSON.stringify(this.fiveKSeries) 
      else delete localStorage.fiveKSeries 
      this.filterActions()
    },
    checkSearchFilter(d){
      let self = this
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase())!=-1)
      {
        return true
      }
      else
      {
        return false
      }
    },
    selectProductNow(d){
      let self = this
      self.pickProduct = true
      self.selectedProduct = d
      localStorage.selected_product = JSON.stringify(self.selectedProduct)
      self.refreshReview()
      self.isProductModal = false
    },
    showProductModal(){
      let self = this
      self.isProductModal = true
    },
   
    goToCompliance(){
      let self = this
      localStorage.selectedWebComplianceScore = self.selectedWebComplianceScore
      window.location =  "#/compliance-detail-demo"
    },
    formatDate(key,d){
      let self = this
      let obj = {
        'day': moment(d).format('MMM DD, YY'),
        'month': moment(d).format('MMM YY'),
        'week': ''
      }
      if (self[key]=='week')
      {
        let end_date = moment(d).add(6,'days')
        let today = moment(self.date.startDate)
        if(end_date >= today)
          end_date = today

        let weekStart = moment(d).format('MMM DD, YY')
        let weekEnd = moment(end_date).format('MMM DD, YY')

        if(moment(d) < moment(this.sovStartDate)) 
           weekStart =  moment(this.sovStartDate).format('MMM DD, YY')

        if(moment(end_date) > moment(this.sovEndDate))
          weekEnd = moment(this.sovEndDate).format('MMM DD, YY')

        obj['week'] =  weekStart + " - " +  weekEnd
      }
      return obj[this[key]]
    },
    formatDate(key,d){
      let self = this
      let obj = {
        'day': moment(d).format('MMM DD, YY'),
        'month': moment(d).format('MMM YY'),
        'week': ''
      }
      if (self[key]=='week')
      {
        let end_date = moment(d).add(6,'days')
        let today = moment(self.date.startDate)
        if(end_date >= today)
          end_date = today

        let weekStart = moment(d).format('MMM DD, YY')
        let weekEnd = moment(end_date).format('MMM DD, YY')

        if(moment(d) < moment(this.sovStartDate)) 
           weekStart =  moment(this.sovStartDate).format('MMM DD, YY')

        if(moment(end_date) > moment(this.sovEndDate))
          weekEnd = moment(this.sovEndDate).format('MMM DD, YY')

        obj['week'] =  weekStart + " - " +  weekEnd
      }
      return obj[this[key]]
    },
    drawReviewGraph(reviewData){
      let self = this
      self.totalReviewCount = reviewData.count
      self.ratingAvg = 0
      let revRat = [
        { label:'Review', key:'review_count', graph:'reviewGraph', active:'activeReviewGraph' },
        { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' },
        { label:'cumulative Review', key:'commulative_review_count', graph:'creviewGraph', active:'activeReviewGraph' },
        { label:'cumulative Rating', key:'commulative_rating', graph:'cratingGraph', active:'activeReviewGraph' },
        // { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' }
      ]
      if (reviewData.timeline.length)
        self.ratingAvg = reviewData.timeline[reviewData.timeline.length-1].commulative_rating.toFixed(1)
      let y_labels = ['Review Count','Avg. Rating','Cumulative Review Count','Cumulative Rating']
      let tick_arr = [50,1]
      let max_arr = [undefined,5]
      for (let [ii, rr] of revRat.entries())
      {
        let cat = []
        let data = []
        for(let [idx, dataset] of reviewData.timeline.entries()) 
        {
          cat.push(self.formatDate('revInterval',dataset.date))
          data.push(dataset[rr.key])
        }
        self[rr.graph] = {
          chart: {
              type: 'line',
              height:180
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          xAxis: {
              categories: cat,
              title: {
                  text: null
              }
          },
          plotOptions: {
              line: {
                  // dataLabels: {
                  //     enabled: true,
                  //     style:{fontWeight:0},
                  //     formatter:function(){
                        
                  //       let d = this.series.userOptions.detail[this.point.index]
                      
                  //       return this.point.y + '% (' + d + ')'
                  //     },
                  // }
              }
          },
          yAxis: {
              min: 0,
              tickInterval:tick_arr[ii],
              max:max_arr[ii],
              title: {
                  text: y_labels[ii],
        
              },
          },
          tooltip: {
            formatter: function() {
                  var mytooltip = this.key + '<br/>';
                  
                  mytooltip += '<span style="color:' + this.series.color + '">\u25CF</span> '
                    mytooltip += this.series.name
                    mytooltip += ' : <b> ' + self.format(this.y);

                    mytooltip += '</b><br/>'
                  
                  return mytooltip;
                },
          },
        
          legend: {
              enabled:false
          },
          credits: {
              enabled: false
          },
          series: [{
              name: rr.label,
              data: data,
              color: '#ffa500a8',
          }]
        }
        if(rr.graph=='ratingGraph')
          self['ratingGraph']['yAxis']['min'] = 1
        setTimeout(function(){
          self[rr.active] = true
        },200)
      }
    },
    getReviews(){
      let self = this
      self.loader = true
      self.activeReviewGraph = false
      let payload = {
        "start_date":moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date":moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "interval": self.revInterval,
        "client": "AMD",
        "item_category": self.device,
      }
      if(self.sponCheck)
      {
        payload['sponsored'] =  self.sponCheck
      }
      if(self.brandFilter)
      {
        payload['brand'] = self.brandFilter
      }
      if(self.cpuFilter)
      {
        payload['processor'] = self.cpuFilter
      }

      if (self.selected_website != 'all')
      {
        payload["channel"] = self.websitesUrls[self.selected_website]
      }
      if ( self.selectedProduct.key != 'all')
      {
        payload["product_name"] = self.selectedProduct.key
      }
      if(self.ratingInput1 || self.fourKSeries || self.fiveKSeries)
      {
        if(self.pickProduct)
        {
          if(self.selectedProduct.key!='all')
            payload["product_name"] = self.selectedProduct.key
          else
          {
            payload["product_name"] = []
            for (let [ii, rr] of this.productOptions.entries())
            {
               payload["product_name"].push(rr.key)
            }
          }
        }
        else 
        {
          payload["product_name"] = []
          for (let [ii, rr] of this.productOptions.entries())
          {
            payload["product_name"].push(rr.key)
          }
        }  
      }
     
      const url = "/api/websites/review_histogram"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.drawReviewGraph(response.body.data)
      }, err => {
        self.loader = false
      });

    },
    refreshReview(){
      let self = this
      if(self.selectedProduct)
        self.getReviews()
    },
    filterActions(){
      this.productOptions = []
      let brandCheck = true
      let cpuCheck = true
      let ratingCheck = true
      let seriesCheck = true
      
      let ratingExpMapper= {
          'eq': function(a,b){ return a==b},
          'gt': function(a,b){ return b>a},
          'gte': function(a,b){ return b>=a},
          'lt': function(a,b){ return b<a},
          'lte': function(a,b){ return b<=a},
          'between': function(a1,a2,b){ return ((b>=a1)&&(b<=a2))}
      } 
      for (let [ii, rr] of this.productOptionsFull.entries())
      {
        if(this.brandFilter)
          brandCheck = this.brandFilter == rr.brand_name
        if(this.cpuFilter)
          cpuCheck = this.cpuFilter == rr.processor_type
        if(this.ratingExp != 'between' && this.ratingInput1 )
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1,rr.rating)
        else if(this.ratingExp == 'between' && this.ratingInput1 && this.ratingInput1 )
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1,this.ratingInput2,rr.rating)
        
        if(this.fourKSeries && this.fiveKSeries )
          seriesCheck = (rr.processor_model[0] == '4') || (rr.processor_model[0] == '5')
        else if(this.fourKSeries && !this.fiveKSeries )
          seriesCheck = (rr.processor_model[0] == '4') 
        else if(!this.fourKSeries && this.fiveKSeries ) 
           seriesCheck = (rr.processor_model[0] == '5')   
        if(brandCheck && cpuCheck && ratingCheck && seriesCheck )
        {
          this.productOptions.push(rr)
        }
      }
      this.refreshReview()
    },
    refreshReview(){
      let self = this
      localStorage.reviewStartDate = this.reviewStartDate
      localStorage.reviewEndDate = this.reviewEndDate
      if(self.selectedProduct)
        self.getReviews()
    },
    getProducts(){
      let self = this
      self.loader = true
      self.productOptions = []
      self.selectedProduct = {}
      self.productOptionsFull = []
      const url = "/api/websites/website_products"
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      payload['start_date'] = moment(self.reviewStartDate).format('YYYY-MM-DD')
      payload['end_date'] = moment(self.reviewEndDate).format('YYYY-MM-DD')
    
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(!self.oem_websites.includes(idx)) payload["website"].push(idx) 
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.errorInProduct = false
        if (!response.body.data.length)
        {
          self.selectedProduct = {key:'all'}
          self.drawReviewGraph({count:0,timeline:[]})
          return
        }
        // self.productOptions = response.body.data.sort()
        self.productOptionsFull = response.body.data
        self.filterKeys.brand = response.body.brand_list.sort()
        self.filterKeys.processor_type = response.body.processor_list.sort()
       
       if (localStorage.selected_product)
          self.selectedProduct = JSON.parse(localStorage.selected_product)
        else
        {
          self.selectedProduct = {key:'all'}  
          localStorage.selected_product = JSON.stringify(self.selectedProduct)
        }
        self.filterActions()
       
      }, err => {
        self.loader = false
        self.errorInProduct = true
      });
    },
    goToDetailPage(){
      window.location = "#/sov-detailed-demo"
    },
    goToSenti(){
      window.location = "#/reviewlist-demo"
    },
    drawDailyChartCompareRyzen(d){
      let self = this 
      let keys = [
        {key:'cpu3',amd:'amd_ryzen_3_sov',intel: 'intel_core_i3_sov',amdLabel:'AMD Ryzen 3',intelLabel:'Intel Core i3'},
        {key:'cpu5',amd:'amd_ryzen_5_sov',intel: 'intel_core_i5_sov',amdLabel:'AMD Ryzen 5',intelLabel:'Intel Core i5'},
        {key:'cpu7',amd:'amd_ryzen_7_sov',intel: 'intel_core_i7_sov',amdLabel:'AMD Ryzen 7',intelLabel:'Intel Core i7'},
        {key:'cpu9',amd:'amd_ryzen_9_sov',intel: 'intel_core_i9_sov',amdLabel:'AMD Ryzen 9',intelLabel:'Intel Core i9'},
      ]  
      for(let [idx, dataset] of keys.entries()) 
      {
        let categories = []
        let amdData = []
        let intelData = []
        for(let [i2, d2] of d.entries()) 
        {  
          categories.push(self.formatDate('sovInterval',d2.timestamp))
          amdData.push(Math.round(d2[dataset.amd])) 
          intelData.push(Math.round(d2[dataset.intel])) 
        }  
        let obj = {}
        self.dailyCompareRyzen[dataset.key] = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: ''
        },
        xAxis: {
            categories: categories,
            labels:{
              style:{color:this.$parent.darkMode ? 'white' : '#666666'}
            },
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                      allowOverlap:true,
                    style:{fontWeight:0},
                    color:this.$parent.darkMode ? 'white' : '#666666',
                    formatter:function(){ 
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6', 
            title: {
                text: '',

            },
        },
        tooltip: {
          shared:true
        },

        legend: {
            enabled:true,
            itemStyle:{color:this.$parent.darkMode ? 'white' : '#666666'}
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: dataset.amdLabel + ' SOV',
            data: amdData,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
        },{
            name: dataset.intelLabel + ' SOV',
            data: intelData,
            color: '#ffa500a8',
            tooltip: {
                valueSuffix: ' %'
            },
        }]
      }
      }  
      
    },
    drawDailyChart(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      let gamingData = []
    
      for(let [idx, dataset] of this.dailyData.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = dataset.page_count
        let ryzensov = Number(dataset.ryzen_sov.toFixed())
        let nonryzensov = Number(dataset.non_ryzen_sov.toFixed())
        data3.push(ryzensov)
        data4.push(nonryzensov)
        amdSov.push(ryzensov + nonryzensov)
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      if(!this.retail_websites.includes(this.selected_website)) {
        for(let [idx, dataset] of this.dailyDataGaming.data.entries()) {
          gamingData.push(Math.round(dataset.gaming_laptop_sov))
        }
      }
      
      let obj = {}
      self.daywiseChart = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total ' + self.deviceMapper[self.device]  + ': '+laptop_count,
            style:{color: this.$parent.darkMode ? 'white' : '#666666' }
        },
        xAxis: {
            categories: categories,
            labels:{
              style:{color:this.$parent.darkMode ? 'white' : '#666666'}
            },
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                    color:this.$parent.darkMode ? 'white' : '#666666',
                     allowOverlap:true,
                    style:{fontWeight:0},
                    
                    formatter:function(){ 
                      let category = this.point.category
                      let plotY = this.point.plotY
                      if(obj.hasOwnProperty(category))
                        obj[category].push(plotY)
                      else
                      {
                        obj[category] = []
                          obj[category].push(plotY)
                      }  
                      let plotYPos = obj[category].indexOf(plotY)
                      let prvPlotY = obj[category][plotYPos-1]
                      if( plotYPos > 0)
                      {
                        if((plotY - prvPlotY < 9) && (plotY - prvPlotY > -9))
                        {
                          this.point.plotY = this.point.plotY + 9
                          obj[category][plotYPos] = this.point.plotY
                        }
                      }
                      let d = this.series.userOptions.detail[this.point.index]
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6', 
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true,
            itemStyle:{color:this.$parent.darkMode ? 'white' : '#666666'}
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'AMD SOV',
            data: amdSov,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        },{
            name: 'Ryzen SOV',
            data: data3,
            color: '#ffa500a8',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail1
        }, {
            name: 'Non-Ryzen SOV',
            data: data4,
            color: 'grey',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail2
        },
        {
          name: 'AMD Gaming SOV',
          data: gamingData,
          color: '#ff8ac4',
          tooltip: {
            valueSuffix: ' %'
          },
          detail: detail2
        }]
      }
      if(this.retail_websites.includes(this.selected_website)) {
        self.daywiseChart.series.splice(self.daywiseChart.series.length-1,1)
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    getAllDailyData(){
      this.getDailyData();
      this.getdailyCompareRyzen()
    },
    getDailyData(){
      let self = this
      self.loader4 = true
      let url = "/api/amazon_india/daily_sov"
      if (self.retail_websites.includes(self.selected_website)){
        url = "/api/websites/daily_sov"
      }
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
      payload["interval"] = self.sovInterval
      payload["start_date"] = moment(self.sovStartDate).format('YYYY-MM-DD')
      payload["end_date"] = moment(self.sovEndDate).format('YYYY-MM-DD')
      payload["timestamp"] = moment(self.sovEndDate).format('YYYY-MM-DD')
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(dataset !='hp') payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url, payload).then(response => {
        self.loader4 = false
        self.dailyData = response.body.data
        if (self.retail_websites.includes(self.selected_website)){
          if(self.selected_website == 'https://global.jd.com')
          {
            self.dailyDataGamingPage13 = response.body.gaming_data
            self.dailyDataAveragePage13 = response.body.average_data
            self.drawDailyChartGamingPage13()
            self.drawDailyChartAveragePage13()
            self.drawDailyAMDCountGaming(response.body.gaming_all_data)
            self.drawDailyAMDCountAverage(response.body.average_all_data)
          }
          self.allProcessorData = response.body.all_processor_data
          self.page1ProcessorData = response.body.page_1_processor_data
          self.dailyDataPage1 = response.body.page_1_data
          self.drawDailyChart()
          self.drawDailyChartPage1()
          self.drawDailyAMDCount(response.body.all_data)
          self.drawDailyPagePosition(response.body.page_data)
        } 
        else {
          self.getDailyDataGaming()
        }
        
      }, err => {
        self.loader4 = false
      });
    },
    drawDailyChartPage1(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      for(let [idx, dataset] of this.dailyDataPage1.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = dataset.page_count
        let ryzensov = Number(dataset.ryzen_sov)
        let nonryzensov = Number(dataset.non_ryzen_sov)
        data3.push({y:ryzensov,count:dataset.ryzen,total:dataset.page_count})
        data4.push({y:nonryzensov,count:dataset.non_ryzen,total:dataset.page_count})
        amdSov.push({y:Number(dataset.amd_sov),count:dataset.amd_count,total:dataset.page_count})
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      let obj = {}
      self.daywiseChartPage1 = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total ' + self.deviceMapper[self.device]  + ': '+laptop_count
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                     allowOverlap:true,
                    style:{fontWeight:0},
                    
                    formatter:function(){ 
                      let category = this.point.category
                      let plotY = this.point.plotY
                      if(obj.hasOwnProperty(category))
                        obj[category].push(plotY)
                      else
                      {
                        obj[category] = []
                          obj[category].push(plotY)
                      }  
                      let plotYPos = obj[category].indexOf(plotY)
                      let prvPlotY = obj[category][plotYPos-1]
                      if( plotYPos > 0)
                      {
                        if((plotY - prvPlotY < 9) && (plotY - prvPlotY > -9))
                        {
                          this.point.plotY = this.point.plotY + 9
                          obj[category][plotYPos] = this.point.plotY
                        }
                      }
                      let d = this.series.userOptions.detail[this.point.index]
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'AMD SOV',
            data: amdSov,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        },{
            name: 'Ryzen SOV',
            data: data3,
            color: '#ffa500a8',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail1
        }, {
            name: 'Non-Ryzen SOV',
            data: data4,
            color: 'grey',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail2
        }]
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    getDailyDataGaming(){
      let self = this
      self.loader4 = true
      const url = "/api/amazon_india/get_gaming_sov_trendline"
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      payload["interval"] = self.sovInterval
      payload["start_date"] = moment(self.sovStartDate).format('YYYY-MM-DD')
      payload["end_date"] = moment(self.sovEndDate).format('YYYY-MM-DD')
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
      payload["website"].push(self.selected_website)
      self.$http.post(url, payload).then(response => {
        self.loader4 = false
        self.dailyDataGaming = response.body.data
        self.drawDailyChart()
      }, err => {
        self.loader4 = false
      });
    },
    
    processCategorySearchGraph(){
      let self = this
      let cat = self.pageDistributionData.category
      let srch = self.pageDistributionData.search
      let catTotal =  cat[1] + cat[2] + cat[3] 
      let srchTotal =  srch[1] + srch[2] + srch[3] 

      self.categorySearchGraph = {      
        chart: {
            type: 'column',
            height: 320
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        legend:{itemStyle:{color:this.$parent.darkMode ? 'white' : '#666666'}},
        xAxis: {
            opposite: true,
            categories: [ self.deviceMapper[self.device]  + ' category page', self.deviceMapper[self.device]  + ' search page'],
            labels:{
              style:{color:this.$parent.darkMode ? 'white' : '#666666'}
            },
        },
        yAxis: {
          min: 0,
          gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6', 
          max: 100,
          title: {
              text: ''
          },
      },        
        tooltip: {
           enabled: false,
    
        },

        plotOptions: {
            column: {
                stacking: 'percent',
                dataLabels: {
                  enabled: true,
                  useHTML: true,
                  zIndex:0,
                  formatter: function() {
                    
                    return  '<span style="color:white;font-size:10px;font-weight:normal;background-color:#00000085;padding:4px">' +self.format(Number(this.point.percentage.toFixed())) + '% </span>'
                },
               }
            }
        },
        series: [{
            name: 'Page 1',
            data: [cat[1],srch[1]],
            color:'#00800080',
            borderWidth: 0,
        }, {
            name: 'Page 2',
            data: [cat[2],srch[2]],
            color:'#ffa5008a',
            borderWidth: 0,
        },{
            name: 'Page 3',
            data: [cat[3],srch[3]],
            color:'#ff00008a',
            borderWidth: 0,
        } ]
      }
      if(self.selected_website=="https://store.hp.com/us")
      {
        self.categorySearchGraph.xAxis.categories = [ self.deviceMapper[self.device]  + ' category page']
        self.categorySearchGraph.series = [{
            name: 'Page 1',
            data: [cat[1]],
            color:'#00800080',
            borderWidth: 0,
        }, {
            name: 'Page 2',
            data: [cat[2]],
            color:'#ffa5008a',
            borderWidth: 0,
        },{
            name: 'Page 3',
            data: [cat[3]],
            color:'#ff00008a',
            borderWidth: 0,
        } ]
      }
    },
    processSOVSOSGraph(){
      let self = this
      let sov = {
        ryzen: ((self.pageDistributionData.sov.ryzen)/self.pageDistributionData.sov.total)*100,
        nonRyzen: ((self.pageDistributionData.sov.non_ryzen)/self.pageDistributionData.sov.total)*100,
      }
      let sos = {
        ryzen: ((self.pageDistributionData.sos.ryzen)/self.pageDistributionData.sos.total)*100,
        nonRyzen: ((self.pageDistributionData.sos.non_ryzen)/self.pageDistributionData.sos.total)*100,
      }
      sov.ryzen = Number(sov.ryzen.toFixed())
      sov.nonRyzen = Number(sov.nonRyzen.toFixed())
      sos.ryzen = Number(sos.ryzen.toFixed())
      sos.nonRyzen = Number(sos.nonRyzen.toFixed())
      let maxScale = sos.ryzen+sos.nonRyzen + 5
      if (sov.ryzen+sov.nonRyzen > sos.ryzen+sos.nonRyzen)
      {
        maxScale = sov.ryzen+sov.nonRyzen + 5
      }
      self.sovSOSGraph = {      
        chart: {
            type: 'column',
            height:320,
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            opposite: true,
            labels:{
              style:{color:this.$parent.darkMode ? 'white' : '#666666'}
            },
            categories: [
              'All '+ self.deviceMapper[self.device]  +' Category Pages <br/> Total '+ self.deviceMapper[self.device]  +' = ' + self.pageDistributionData.sov.total,
              'All '+ self.deviceMapper[self.device]  +' Search Pages <br/> Total '+ self.deviceMapper[self.device]  +' = ' + self.pageDistributionData.sos.total
            ]
        },
        yAxis: { 
          min: 0,
          gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6', 
          max: maxScale,
          title: {
              text: ''
          },
          stackLabels: {
            enabled:true,
            formatter:function(){
              let suf = ''
              let total = ''
              if (this.x==0)
              {
                suf = (self.pageDistributionData.sov.ryzen + self.pageDistributionData.sov.non_ryzen )
                total = self.pageDistributionData.sov.total
              }  
              else  
              { 
                suf = (self.pageDistributionData.sos.ryzen + self.pageDistributionData.sos.non_ryzen )
                total = self.pageDistributionData.sos.total
              }  
              return 'AMD:' + this.total + '%' 
            }
          }
      
      },        
        tooltip: {
           enabled:false,
          
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                  enabled: true,
                  useHTML: true,
                  formatter: function() {
                    let mapper = {}
                    let d = this.series.userOptions.myData[this.point.index]
                    
                    mapper['Ryzen SOV'] = d.ryzen + '/' + d.total
                    mapper['Non-Ryzen SOV'] = d.non_ryzen + '/' + d.total
                    
                    return  '<span style="color:white;font-size:11px;font-weight:normal;background-color:#00000085;padding:2px">' +self.format(this.point.y) + '%'
                },
               }
            }
        },
        series: [{
            name: 'Ryzen SOV',
            data: [sov.ryzen,sos.ryzen],
            color:'#ffa500a8',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov,self.pageDistributionData.sos]
        }, {
            name: 'Non-Ryzen SOV',
            data: [sov.nonRyzen,sos.nonRyzen],
            color:'grey',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov,self.pageDistributionData.sos]
         }
        ]
      }
      if(self.selected_website=="https://store.hp.com/us")
      {
        self.sovSOSGraph.xAxis.categories = ['All '+ self.deviceMapper[self.device]  +' Category / Search Pages <br/> Total '+ self.deviceMapper[self.device]  +' = ' + self.pageDistributionData.sov.total]
        self.sovSOSGraph.series = [{
            name: 'Ryzen SOV',
            data: [sov.ryzen],
            color:'#ffa500a8',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov]
        }, {
            name: 'Non-Ryzen SOV',
            data: [sov.nonRyzen],
            color:'grey',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov]
         }
        ]
      }

    },
    processDisablingDates(){
      this.date.disabled = {
        'startRange': {
          from: moment(this.date.endDate).toDate(),
          to: ''
        },
        'endRange': {
          from: moment().subtract(1,'day').toDate(),
          to: moment(this.date.startDate).toDate()
        }
      }
      if(this.oemSites.includes(this.selected_website))
      {
        this.date.disabled = {
          'startRange': {
            from: moment(this.date.endDate).toDate(),
            to: ''
          },
          'endRange': {
            from: moment().subtract(1,'day').toDate(),
            to: moment('2022-03-04').toDate()
          }
        }
      }
    },
    ryzenVsNonRyzen(){
      let self = this
      self.loader3 = true
      self.activecategorySearchGraph = false
      const url = "api/amazon_india/page_position"
      let payload = {}
      payload["website"] = [self.selected_website]
      payload["item_category"] = self.device
      payload["start_date"]  = self.date.startDate
      payload["end_date"]  = self.date.endDate
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
      self.$http.post(url,payload).then(response => {
        self.loader3 = false
        self.pageDistributionData = response.body.data
        self.processSOVSOSGraph()
        self.processCategorySearchGraph()
        self.activecategorySearchGraph = true
      }, err => {
        self.loader3 = false
      });
    },
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      this.brandFilter = ''
      this.cpuFilter = ''
      $('#myTable').DataTable().destroy();
      if(localStorage.selected_website!=this.selected_website)
        delete localStorage['selected_product'];
      if(localStorage.selected_category!=this.device)
        delete localStorage['selected_product'];
      if(this.selected_website != 'all')
        localStorage.selected_website = this.selected_website
      localStorage.selected_category = this.device
      this.showBrand = true
      this.showBrandHP = true
      this.labelMapper = {
        'brand': 'Brand',
        'processor_type': 'AMD Processor',
        // 'gpu_type': 'GPU'
      }
      if(this.price_sites.includes(this.selected_website))
        this.isPrice = true
      else
        this.isPrice = false 
      this.processDisablingDates()
      if(this.retail_websites.includes(this.selected_website)){
        this.getDailyData()
        this.getProducts()
        this.getComData()
        this.website_details()
        this.getPriceBands()
        this.priceBandsProcessor()
      }
      else if(this.oemSites.includes(this.selected_website)){
        this.newTrendSOVSOS()
        this.newSOVSOS()
        this.getComplianceTrend()
        this.getComData()
        this.website_details()
        this.getProducts()
      }
      else
      {
        this.callAllAPI() 
      }
    },
  	sov(){
      let self = this
      self.activeChart = false
      self.loader = true
      const url = "/api/amazon_india/gaming_laptop_sov"
      let payload = {}
      payload["website"] = [self.selected_website]
      payload["item_category"] = self.device
      payload["start_date"]  = self.date.startDate
      payload["end_date"]  = self.date.endDate
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
  		this.$http.post(url, payload).then(response => {
        this.rows = response.body.data.sov
        this.sos_rows = response.body.data.sos
        self.renderSovCharts()
        
      }, err => {
        self.loader = false
      });
    },

    renderSovCharts()
    {
      let self = this
      let xaxis = []
      let data1 = []
      let data2 = []
      let data3 = []
      let data4 = []
      let max1 = 0
      let max2 = 0
      let limit = 9
      let textCat = 'Page 1 Count: <b>' +self.rows[0].page_1_count + 
                '</b><br/>Pages 1-3 Count: <b>'+self.rows[0].page_1_3_count
                // '</b><br/>AMD '+ self.deviceMapper[self.device]  +' Count: <b>' +  (self.rows[0].page_all_system_count + self.rows[1].page_all_system_count) + '</b>'
      let textSch = 'Page 1 Count: <b>' + self.sos_rows[0].page_1_count + 
                    '</b><br/>Pages 1-3 Count: <b>'+self.sos_rows[0].page_1_3_count
                    // '</b><br/>AMD '+ self.deviceMapper[self.device]  +' Count: <b>' +  (self.sos_rows[0].page_all_system_count+self.sos_rows[1].page_all_system_count) + '</b>'
      if ((self.rows[0].page_all_system_count == 0 ) || (self.selected_website == 'all')) 
      {
        textCat = 'Page 1 Count: <b>' +self.rows[0].page_1_count + 
                '</b><br/>Pages 1-3 Count: <b>'+self.rows[0].page_1_3_count + '</b>'
        textSch = 'Page 1 Count: <b>' + self.sos_rows[0].page_1_count + 
                    '</b><br/>Pages 1-3 Count: <b>'+self.sos_rows[0].page_1_3_count+ '</b>' 
        limit = 9
      }
      for(let [idx, dataset] of self.columns.slice(3,limit).entries()) 
      {

        if((dataset.field!='page_1_count') && (dataset.field!='page_all_count') && (dataset.field!='page_1_system_count') && (dataset.field!='page_all_system_count') && (dataset.field!='page_1_3_count')&& (dataset.field!='page_1_3_system_count'))
        {
          var d1 = Number(self.rows[0][dataset.field].toFixed())
          var d2 = Number(self.rows[1][dataset.field].toFixed())
          var d3 = Number(self.sos_rows[0][dataset.field].toFixed())
          var d4 = Number(self.sos_rows[1][dataset.field].toFixed())
          if(d1>=max1) max1 = d1
          if(d2>=max1) max1 = d2
          if(d3>=max2) max2 = d3
          if(d4>=max2) max2 = d4
          xaxis.push(dataset.label)
          data1.push(d1)
          data2.push(d2)
          data3.push(d3)
          data4.push(d4)
        }
      }    
      xaxis.push('Pages 1-3 gaming SOV')
      self.charts = 
        {
          credits: {
            enabled: false
          },
          chart: {
            type:'column',
            height:320,
            inverted:true
          },
          title: {
            text: ''
          },
          subtitle: {
              align:'left',
              text: textCat,
              style:{color: this.$parent.darkMode ? 'white' : '#666666' }
          },
          yAxis: {
              title: {
                  text: ''
              },
              max:max1 + 5,
              gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6' 
          },
          legend:{itemStyle:{color:this.$parent.darkMode ? 'white' : '#666666'}},
          plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    color:this.$parent.darkMode ? 'white' : '#666666',
                    inside: false,
                    formatter:function(){
                        return this.point.y + '%'
                    }
                }
            }
},
          xAxis:{
            categories: xaxis,
            labels:{
              style:{color:this.$parent.darkMode ? 'white' : '#666666'}
            },
            crosshair: true,
          },
          tooltip: {
            formatter: function() {
              var mytooltip = this.points[0].key + '<br/>';
              for(var i = 0;i<this.points.length;i++)
              {
                mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
                mytooltip += this.points[i].series.name
                mytooltip += ' : <b> ' + self.format(this.points[i].y);
                if(this.points[0].key.indexOf('SOV')!=-1)
                  mytooltip += '%'
                mytooltip += '</b><br/>'
              }
              return mytooltip;
            },
            shared: true
          },
          series: [ 
          {
            name: 'AMD SOV',
            data:data1,
            color:'#ffb9b9',
            allData: self.rows[0] 
          }, 
          { 
            name: 'Intel SOV',
            data:data2,
            color:'#c7e0ff',
            allData: self.rows[1] 
          } ]
        }
       if(self.device=='laptop')  
      {
        self.charts.series.push({ 
            name: 'AMD Gaming SOV',
            data: [null,null,Math.round(self.rows[0]['page_1_3_gaming_sov'])],
            color: '#f58279',
            allData: self.rows[1],
            grouping: true 
          })
        self.charts.series.push({ 
            name: 'Intel Gaming SOV',
            data: [null,null,Math.round(self.rows[1]['page_1_3_gaming_sov'])],
            color: 'blue',
            allData: self.rows[1],
            grouping: true 
          })  
      }  

      self.charts_sos = 
        {
          credits: {
            enabled: false
          },
          chart: {
            type:'column',
            height:320,
            inverted:true
          },
          title: {
            text: ''
          },
          subtitle: {
              align:'left',
              text: textSch,
              style:{color: this.$parent.darkMode ? 'white' : '#666666' }
          },

          yAxis: {
              title: {
                  text: ''
              },
              max: max2 + 5,
              gridLineColor: this.$parent.darkMode ? '#2f2f2f' : '#e6e6e6' 
          },
            plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    color:this.$parent.darkMode ? 'white' : '#666666',
                    formatter:function(){
                        return this.point.y + '%'
                    }
                }
            }
          },
          legend:{itemStyle:{color:this.$parent.darkMode ? 'white' : '#666666'}},
          xAxis:{
            categories: xaxis,
            labels:{
              style:{color:this.$parent.darkMode ? 'white' : '#666666'}
            },
            crosshair: true,
          },
          tooltip: {
            formatter: function() {
              var mytooltip = this.points[0].key + '<br/>';
              for(var i = 0;i<this.points.length;i++)
              {
                mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
                mytooltip += this.points[i].series.name
                mytooltip += ' : <b> ' + self.format(this.points[i].y);
                if(this.points[0].key.indexOf('SOV')!=-1)
                  mytooltip += '%'
                mytooltip += '</b><br/>'
              }
              return mytooltip;
            },
            shared: true
          },
          series: [ 
          {
            name: 'AMD SOV',
            data:data3,
            color:'#ffb9b9',
            allData: self.sos_rows[0] 
          }, 
          { 
            name: 'Intel SOV',
            data:data4,
            color:'#c7e0ff',
            allData: self.sos_rows[1] 
          }]
        }
      if(self.device=='laptop')  
      {
        self.charts_sos.series.push({ 
            name: 'AMD Gaming SOV',
            data: [null,null,Math.round(self.sos_rows[0]['page_1_3_gaming_sov'])],
            color: 'red',
            allData: self.rows[1],
            grouping: true 
          } )
        self.charts_sos.series.push({ 
            name: 'Intel Gaming SOV',
            data: [null,null,Math.round(self.sos_rows[1]['page_1_3_gaming_sov'])],
            color: 'blue',
            allData: self.rows[1],
            grouping: true 
          } )  
      }
      $('#myTable').DataTable();
      self.activeChart = true

    },
    format(v)
    {
      return this.$options.filters.format(v)
    }, 
    countIt(listingType,dataset){
      let self = this
      for(let [i, d] of Object.entries(this.labelMapper))
      {
        if(dataset[i]=="" || dataset[i]==" " ) dataset[i] = "N/A"
        if(dataset[i].indexOf('amd')!=-1) dataset[i] = dataset[i].replace('amd','AMD')
        if(dataset[i].indexOf('hp')!=-1) dataset[i] = dataset[i].replace('hp','HP')
        if (isNaN(self[listingType][i][dataset[i]]))
          self[listingType][i][dataset[i]] = 1
        else  
          self[listingType][i][dataset[i]]++
      } 
    },
    getColorShades(baseColor){
      if(this.index[baseColor] > this.colorShades[baseColor].length-1)
      {
        this.index[baseColor] = 0
      }
      let c = this.colorShades[baseColor][this.index[baseColor]]
      this.index[baseColor]++
      return c
    },
    generatePieCharts(listingType,chartKey){
      let self = this
      for(let [idx, dataset] of Object.entries(self[listingType])) 
      {
        let seriesData = []
        let finalSeriesData = []
        let color_codes = ['#78b2fb','#cefb78','#fb7878','#b0e1ff','#78eefb','#91ce8e','#59cdfb','#fbd378','#c139a4']
        let color_index = 0
        let color_index1 = 0
        let color_index3 = 0
        for(let [idx2, dataset2] of Object.entries(dataset))
        {
          let obj = {}
          let color = {}
          let whichCpu = ''
          let whichGpu = ''
          if (idx=='brand') 
          {
            color[idx2] = color_codes[color_index3]
            color_index3 = color_index3 + 1
          } 
          else if (idx=='processor_type') 
          {
            if ((idx2.indexOf('amd')!=-1)||(idx2.indexOf('AMD')!=-1))
            {
              color[idx2] = color_codes[color_index]
              whichCpu = 'amd' 
            }
            else if ((idx2.indexOf('intel')!=-1) || (idx2.indexOf('pentium')!=-1) || (idx2.indexOf('core')!=-1) )
              {
                whichCpu = 'intel' 
                color[idx2] = color_codes[color_index]
              }
            else
            {
              whichCpu = 'N/A' 
            }
            color_index = color_index + 1  
          }
          else if (idx=='gpu_type') 
          {
            if ((idx2.indexOf('amd')!=-1)||(idx2.indexOf('radeon')!=-1) ) 
            {
              whichGpu = 'amd'
              color[idx2] = color_codes[color_index1]
            }
            else if ((idx2.indexOf('intel')!=-1) || (idx2.indexOf('uhd')!=-1) || (idx2.indexOf('iris')!=-1) || (idx2.indexOf('integrated')!=-1) )
            {
              whichGpu = 'intel'
              color[idx2] = color_codes[color_index1]
            }
            else if ((idx2.indexOf('nvidia')!=-1) || (idx2.indexOf('geforce')!=-1) )
            {
              whichGpu = 'nvidia'
              color[idx2] = color_codes[color_index1]
            }  
            else 
            {
              whichGpu = 'N/A'
            }
            color_index1 = color_index1 + 1
          }
          if (idx2 =='N/A')
            color[idx2] = '#b9c6de'
         
          obj['name'] = idx2 
          obj['y'] = dataset2
          obj['cpu'] = whichCpu
          obj['gpu'] = whichGpu
          if(color[idx2])
            obj['color'] = color[idx2]
          seriesData.push(obj)    
        } 
        if (idx=='brand') 
        {
          finalSeriesData = seriesData
        }
        else if (idx=='processor_type') 
        {
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='N/A') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='amd') finalSeriesData.push(dataset)
          }  
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='intel') finalSeriesData.push(dataset)
          } 
          
        }
        else if (idx=='gpu_type') 
        {
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='N/A') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='amd') finalSeriesData.push(dataset)
          }  
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='intel') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='nvidia') finalSeriesData.push(dataset)
          } 
         
        }
        self[chartKey][idx] = {
          chart: {
            margin: [80,0,35,0],
            padding:[0,0,0,0]
           
          },
          title: {  
              text:   self.deviceMapper[self.device]  +' Category Page ('+ self.selectedPage +') Distribution by ' + self.labelMapper[idx],
              verticalAlign:'bottom',
              style:{fontSize:13,color: this.$parent.darkMode ? 'white' : '#666666'}
          },
          credits: {
            enabled: false
          },
          accessibility: {
            point: {
                valueSuffix: '%'
            }
          },
          tooltip: {
            formatter(){
              var mytooltip = ''
              mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
              mytooltip += this.point.name
              mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
              mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
              return mytooltip;             
            },
          },
          plotOptions: {
              series: {
                  borderWidth: 0,
              },
              pie: {
                  dataLabels: {
                    enabled: true,
                    useHTML: true,
                    formatter: function() { 
                      self.pieTotal = this.point.total 
                     
                      return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                    },
                    distance: -13,
                    style: {
                      fontSize: 11,
                    }  
                  },
                  showInLegend: true,
                  size: '100%'
              }
          },
          legend:{
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'top',
            itemStyle: {
              fontSize: 11,
              color:this.$parent.darkMode ? 'white' : '#666666',
              fontWeight: 1
            },
            maxHeight: 65, 
          },  
          series: [{  
            type: 'pie',
            data: finalSeriesData
          }]
        } 
        setTimeout(function(){
          self.activePie = true
        },50)
      }
    },
    readyPieCharts(){
      let self = this
      self.clearPieDataset()
      for(let [idx, dataset] of this.rows_details.entries()) 
      {
        if ((self.selectedPage == 1) && (dataset.page!=1)) continue
        if (dataset.processor == 'amd')
        {
          if(self.amdCPUFilter == 'all')
          {
            self.countIt('countAMD',dataset)
          }
          else if (self.amdCPUFilter == 'ryzen')
          {
            if(dataset.processor_type.indexOf('ryzen')!=-1)
              self.countIt('countAMD',dataset)
            else
              continue
         }
         else
         {
           if(dataset.processor_type.indexOf('ryzen')==-1)
              self.countIt('countAMD',dataset)
            else
              continue
         }
        }
      }
      self.generatePieCharts('countAMD','pieChartAMD') 
    },
    createPie(){
      let self = this
      let color_codes = ['#78b2fb','#cefb78','#fb7878','#b0e1ff','#78eefb','#91ce8e','#59cdfb','#fbd378','#c139a4']
      let color_index_total = 0
      let color_index = 0
      let color = {}
      let color_total = {}
      let total = 0
      let seriesData = []
      let totalData = self.total_processor_data
      self.pieTotalAll = 0
      for(let [idx, dataset] of totalData.entries())
      {
        color_total[dataset.name] = color_codes[color_index_total]
        color_index_total = color_index_total + 1
        dataset.color = color_total[dataset.name]
        self.pieTotalAll = self.pieTotalAll + dataset.y
      }
      self['pieChartAMDTotal'] = {
            chart: {
              margin: [80,0,35,0],
              padding:[0,0,0,0]
             
            },
            title: {  
                text:  self.deviceMapper[self.device]  +' Category Page ('+ self.selectedPage +') Distribution by Processor',
                verticalAlign:'bottom',
                style:{fontSize:13,color: this.$parent.darkMode ? 'white' : '#666666'}
            },
            credits: {
              enabled: false
            },
            accessibility: {
              point: {
                  valueSuffix: '%'
              }
            },
            tooltip: {
              formatter(){
                var mytooltip = ''
                mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
                mytooltip += this.point.name
                mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
                mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
                return mytooltip;             
              },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                },
                pie: {
                    dataLabels: {
                      enabled: true,
                      useHTML: true,
                      formatter: function() { 
                        return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                      },
                      distance: -13,
                      style: {
                        fontSize: 11,
                      }  
                    },
                    showInLegend: true,
                    size: '100%'
                }
            },
            legend:{
              align: 'center',
              layout: 'horizontal',
              verticalAlign: 'top',
              itemStyle: {
                fontSize: 11,
                fontWeight: 1,
                color:this.$parent.darkMode ? 'white' : '#666666'
              },
              maxHeight: 65, 
            },  
            series: [{  
              type: 'pie',
              data: totalData
            }]
          }
      for(const property in self.labelMapper)
      {
        if(property=='brand')
          seriesData = self.pie_brand
        else if(property=='processor_type')
          seriesData = self.pie_cpu
        for(let [idx, dataset] of seriesData.entries())
        {
          color[dataset.name] = color_codes[color_index]
          color_index = color_index + 1
          dataset.color = color[dataset.name]
          total = total + dataset.y
        }
        for(let [idx, dataset] of seriesData.entries())
        {
          dataset.total = total
        }
        self['pieChartAMD'][property] = {
            chart: {
              margin: [80,0,35,0],
              padding:[0,0,0,0]
             
            },
            title: {  
                text:  self.deviceMapper[self.device]  +' Category Page ('+ self.selectedPage +') Distribution by ' + self.labelMapper[property],
                verticalAlign:'bottom',
                style:{fontSize:13,color: this.$parent.darkMode ? 'white' : '#666666'}
            },
            credits: {
              enabled: false
            },
            accessibility: {
              point: {
                  valueSuffix: '%'
              }
            },
            tooltip: {
              formatter(){
                var mytooltip = ''
                mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
                mytooltip += this.point.name
                mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
                mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
                return mytooltip;             
              },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                },
                pie: {
                    dataLabels: {
                      enabled: true,
                      useHTML: true,
                      formatter: function() { 
                        self.pieTotal = this.point.total 
                       
                        return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                      },
                      distance: -13,
                      style: {
                        fontSize: 11,
                      }  
                    },
                    showInLegend: true,
                    size: '100%'
                }
            },
            legend:{
              align: 'center',
              layout: 'horizontal',
              verticalAlign: 'top',
              itemStyle: {
                fontSize: 11,
                fontWeight: 1,
                color:this.$parent.darkMode ? 'white' : '#666666'
              },
              maxHeight: 65, 
            },  
            series: [{  
              type: 'pie',
              data: seriesData
            }]
          }
          setTimeout(function(){
            self.activePie = true
          },50)
        }
    },
    readyPie(){
      let self = this
      let filter_data = []
      self.pie_brand = []
      self.pie_cpu = []
      self.total_processor_data = []
      this.brand_list = self.pie_data[self.amdCPUFilter][self.selectedPage]['brand_list']
      this.cpu_list = self.pie_data[self.amdCPUFilter][self.selectedPage]['cpu_list']
      this.total_processor_list = self.total_pie_data[self.selectedPage]['data']
      for(let [idx, dataset] of this.brand_list.entries())
      {
        let di = {}
        di['name'] = dataset['key']
        di['y'] = dataset['doc_count']
        if(di['name']=="")
          di['name'] = "N/A"
        if(di['name'].indexOf('amd')!=-1) di['name'] = di['name'].replace('amd','AMD')
        if(di['name'].indexOf('hp')!=-1) di['name'] = di['name'].replace('hp','HP')
        self.pie_brand.push(di)
      }
      for(let [idx, dataset] of this.cpu_list.entries())
      {
        let di = {}
        di['name'] = dataset['key']
        di['y'] = dataset['doc_count']
        if(di['name']=="")
          di['name'] = "N/A"
        if(di['name'].indexOf('amd')!=-1) di['name'] = di['name'].replace('amd','AMD')
        if(di['name'].indexOf('hp')!=-1) di['name'] = di['name'].replace('hp','HP')
        self.pie_cpu.push(di)
      }
      for(let [idx, dataset] of this.total_processor_list.entries())
      {
        let di = {}
        di['name'] = dataset['key']
        di['y'] = dataset['doc_count']
        if(di['name']=="")
          di['name'] = "N/A"
        if(di['name'].indexOf('amd')!=-1) di['name'] = di['name'].replace('amd','AMD')
        self.total_processor_data.push(di)
      }
    
      self.createPie()
    },
    clearPieDataset(){
      let self = this
      for(let [i, d] of Object.entries(this.labelMapper))
      {
        self.countAMD[i] = {}
        self.pieChartAMD[i] = {}
      }
    },
 
    website_details(){
      let self = this
      // self.loader = true
      self.rows_details = []
      self.activePie = false
      // const url = "/api/websites/details"
      let url = "/api/amazon_india/website_metrics"
      let page = null
      if(self.selectedPage == 1)
        page=1
      let payload = {}
      payload["website"] = [self.selected_website]
      payload["start_date"]  = self.date.startDate
      payload["end_date"]  = self.date.endDate
      payload["page"] = page
      payload["processor"] = this.amdCPUFilter
      if (self.selectedBrand) payload["laptop_brand_list"]  = [self.selectedBrand]
      payload["item_category"] = self.device
      
      if (this.oemSites.includes(this.selected_website)){
        url = "/api/amazon_india/oem_website_metrics"
        payload["timestamp"]  = self.date.endDate
      }
      this.$http.post(url, payload).then(response => {
        // this.brand_list = response.body.data.brand_list
        // this.cpu_list = response.body.data.cpu_list
        this.pie_data = response.body.data
        this.total_pie_data = response.body.total_data
        // self.loader = false
        self.readyPie()
        // self.readyPieCharts()
      }, err => {
        self.loader = false
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
      if (this.date.endDate)
        this.date.endDate = moment(this.date.endDate).format('YYYY-MM-DD')
      this.processDisablingDates()   
    },
  
  }
}

</script>

<style scoped>
#priceTable th
{
    text-transform: none;
    font-family: sans-serif;
    font-weight: bolder;
    text-align: center;
    border:1px solid silver!important;
    width: 9%!important
}
#priceTable td
{
  border:1px solid silver!important;
  
}
.amdbg
{
  background-color: #ffb9b9!important;
  
}
.intelbg
{
  background-color: #c7e0ff!important
}
.selectedProduct
{
  background: #8e8d8d!important;
  color: White!important;
}
.eachProduct:hover
{
    background: #d4d4d4;
}
.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
 
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color:#4e4e4e;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycol
{
  padding-right:15px!important;
  padding-left:15px!important;
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle
{
      color: #ffffff;
    background-color: #8a87e8;
    border-color: #8a87e8;
    height:30px;
    border-radius:0
}
.btn-outline-secondary
{
  height:30px;
   border-radius:0;
   line-height: 17px;
   background:white
}
.sovdetails{
      float: right;
    height: 30px;
    margin: 0;
    border-radius: 0;
    font-size: 15px;
    padding: 7px;
    width: max-content;
    cursor: pointer;
    margin-left: 4px;
}
select option {text-transform:capitalize}
.internalsection{
  border-bottom: 1px solid silver;
 
}
.wsbg
{
  background: whitesmoke;
}
.sovshowdetails{
    float: right;
    border-radius: 0;
    font-size: 12px!important;
    padding: 6px;
    width: max-content!important;
    cursor: pointer;
    margin: 4px 5px 0px 0;
    background: #8a87e8;
    height: fit-content;
}
</style>